/* Global Variables */

var name = $("meta[name=xml-type]").attr("content");
var pageType = name === "journal article" ? "journal" : name;
var pageH = 0;
var pageT = 0;
var pageE = 0;
var pageN = 1;
var Cpage = "vp_1";
var pageTs = [];
var pageEs = [];
var pageNs = [];
var Fpages = [];
var Tpages = "";
var hashPos = 0;
var tempScrollTop = "";
var isUserLogged = false;
var imgWidth = "";
var totalWidth = "";
var canonicalURL;

/* End Global Variables */
var Medscape = window.Medscape || {};
(function(Medscape) {
    Medscape.ArticlePage = Medscape.ArticlePage || {};
    Medscape.ArticlePage.type = Medscape.ArticlePage.type || "DEFAULT";
    let _hostName = location.hostname.split(".")[0];
    Medscape._isODP = location.host.split('.').shift() === "decisionpoint";
    Medscape.getImageServer = function () {
        return `img.${window.getDomain()}medscapestatic.com`;
    };
})(Medscape);

// add support when ad blocker is running
if (typeof _isAnArticle === 'undefined') {
    var _isAnArticle;
}
var armsLengthVariants = [10008, 20169, 20167, 20168, 20172, 650142, 650143, 650144, 650146, 650147, 590142, 590143, 590144, 590145, 590146, 49135, 49136, 49137, 49138, 49139, 330144, 330145, 330146, 330147, 330148];

$(document).ready(function() {
    if ($(".partner-badge").length) {
        pageType = "partner";
    }
    // Check the page is Lower Left Rail and append llr-driver
    if (window.location.search.includes('icd=layer-llr')) {
        document.getElementsByTagName('body')[0].classList.add('llr-driver');
    }

    if($(".audio-player").length) {
        const bundleJS = document.createElement('script');
        bundleJS.onload = function() {  /*Audio player bundle loaded.*/ }
        document.body.appendChild(bundleJS);
        bundleJS.src = `//img.${getDomain()}medscapestatic.com/medscape-core/www/js/article/audio-player.js`;

        const aPlayerCSS = document.createElement('link');
        aPlayerCSS.setAttribute("rel", "stylesheet");
		aPlayerCSS.setAttribute("type", "text/css");
        aPlayerCSS.setAttribute('href', `//img.${getDomain()}medscapestatic.com/medscape-core/www/css/article/audio-player.css`);
        aPlayerCSS.preload = "true";
        document.body.appendChild(aPlayerCSS);
    }

    if (PageMetadata.pageSegVars.art == "891937" || PageMetadata.pageSegVars.art == "892073") {
        $(".breadcrumb a").remove();
        $(".breadcrumb").html($(".breadcrumb").text().replace(">", ""));
    }
    var canonicalURL;
    var links = window.document.getElementsByTagName('link');
    $(links).each(function() {
        if ($(this).attr('rel') === "canonical") {
            canonicalURL = $(this).attr('href');
        }
    });

    var vpt = $('meta[name=virtualpages]').attr("content");
    
    let artID = PageMetadata.pageSegVars.art;

    if(artID) {
        if(document.querySelector('.page-no') != null) {
            const pageNo = document.querySelector('.page-no').getAttribute('href');
            if(pageNo && pageNo === artID+'_1') {
                document.querySelector('.page-no').setAttribute('href', artID);
            }
        }
        
        if(document.querySelector('#previous-section a') != null){
            const prevId = document.querySelector('#previous-section a').getAttribute('href');
            if(prevId && prevId === artID+'_1') {
                document.querySelector('#previous-section a').setAttribute('href', artID);
            }
        }

        if(document.querySelector('.sections-nav li a') != null) {
            const pageNo = document.querySelector('.sections-nav li a').getAttribute('href');
            if(pageNo && pageNo === artID+'_1') {
                document.querySelector('.sections-nav li a').setAttribute('href', artID);
            }
        }
        
        if(document.querySelector('#menu-wrapper li a') != null) {
            const pageNo = document.querySelector('#menu-wrapper li a').getAttribute('href');
            if(pageNo && pageNo === artID+'_1') {
                document.querySelector('#menu-wrapper li a').setAttribute('href', artID);
            }
        }
        
    }

    if(artID == "927976"){
        vpt = "false";
    }

    if (typeof s_registered_user_id !== 'undefined'||(PageMetadata && PageMetadata.authVar && PageMetadata.authVar.authLevel && PageMetadata.authVar.authLevel !=0)) {
        isUserLogged = true;
    }

    if (breakpoint <= 2) {
        $(".sections-nav").addClass("mobile-sections-nav");
    } else {
        $(".sections-nav").removeClass("mobile-sections-nav");
    }

    if (Medscape.ArticlePage.type=="DEFAULT" && breakpoint !== 1 && vpt === "true") {
        pageTs.push(pageT);
        pageNs.push(pageN);

        var MaxArtHset = 1498;
        var MinArtHset = 925;

        if (breakpoint === 2) {
            MaxArtHset = 2280;
            MinArtHset = 1520;
        }

        $("#pagination").remove();

        $('#article-content > *').each(function() {
            if (pageH < MaxArtHset) {
                pageH = pageH + $(this).height();
                pageE++;
            } else {
                pageT = pageE;
                pageTs.push(pageT);
                pageEs.push(pageE);
                pageN++;
                pageNs.push(pageN);
                pageH = 0;
            }
        });

        pageEs.push($('#article-content > *').length);
        for (var pn = 0; pn < pageNs.length; pn++) {
            Fpages[pn] = $('#article-content').children().slice(pageTs[pn], pageEs[pn]);
        }
        for (var fn = 0; fn < Fpages.length; fn++) {
            Fpages[fn].wrapAll('<div id="pageN_' + pageNs[fn] + '" class="csdpages" />');
        }
        Tpages = Fpages.length;

        if (Tpages === 1) {
            //alert('one page');
        } else if ($('#pageN_' + Fpages.length).height() < MinArtHset) {
            $('#pageN_' + (Fpages.length - 1)).append($('#pageN_' + Fpages.length).html());
            $('#pageN_' + Fpages.length).remove();
            Tpages = (Fpages.length - 1);
            Fpages.length--;
        }
        for (var ot = 0; ot < Tpages; ot++) {
			if (typeof mscpAbGrp == 'undefined' || !mscpAbGrp) {
				$('#pageN_' + pageNs[ot]).hide();	
			}
        }

        for (var tp = 1; tp <= Tpages; tp++) {
            if ($('#pageN_' + tp + '> *:first-child').is($('p'))) {} else {
                var prevPval = (tp * 1) - 1;
                if ($('#pageN_' + prevPval + '> *:last-child').is($('p'))) {
                    $('#pageN_' + tp).prepend($('#pageN_' + prevPval + '> *:last-child'));
                }

            }
        }

        for (var tp = 1; tp <= Tpages; tp++) {
            if ($('#pageN_' + tp + '> *:last-child').is($('p'))) {} else {
                var NextPval = (tp * 1) + 1;
                if ($('#pageN_' + NextPval + '> *:first-child').is($('p'))) {
                    $('#pageN_' + tp).append($('#pageN_' + NextPval + '> *:first-child'));
                }
            }
        }

        if (Tpages > 1) {

            $("#pagination").remove();
			if (typeof mscpAbGrp == 'undefined' || !mscpAbGrp) {
				$('#legal_block').before($('<div id="pagination"><div id="new-page-nav-text">' + " " + pagination.paginationNews(1, Tpages) + '</div><div id="previous-section"><a href="javascript:void(0);">&nbsp;</a></div><div id="next-section"><a href="javascript:void(0);">' + getNextPageTranslation() + '</a></div></div>'));
			}
        }

        if (Medscape.ArticlePage.type == "DEFAULT") {
            $('#pageN_1').show();
            $('#previous-section').addClass("inactive-section");
        }

        $(document)
            .on('click', '#previous-section a', function() {
            $('#previous-section').addClass("inactive-section");
            var VPpageVal = Cpage.split("_");
            var PvPageNum = Number(VPpageVal[1]) - 1;
            Cpage = "vp_" + ((VPpageVal[1] * 1) - 1);
            clearQueryParams();
            scanOmniVars(true);
            window.location.hash = Cpage;
            VPpageVal = Cpage.split("_");
            var trackingObj = {};
            trackingObj['CPage'] = VPpageVal[1];
            trackingObj['nxOrPrvTrk'] = 'ar-nav_pv' + PvPageNum;
            navTracking(trackingObj, PvPageNum);
        }).on('click', '#next-section', function() {
            $('#next-section').addClass("inactive-section");
            var VPpageVal = Cpage.split("_");
            var NxPageNum = Number(VPpageVal[1]) + 1;
            Cpage = "vp_" + ((VPpageVal[1] * 1) + 1);
            clearQueryParams();
            scanOmniVars(true);
            window.location.hash = Cpage;
            VPpageVal = Cpage.split("_");
            var trackingObj = {};
            trackingObj['CPage'] = VPpageVal[1];
            trackingObj['nxOrPrvTrk'] = 'ar-nav_nx' + NxPageNum;
            navTracking(trackingObj, NxPageNum);
        }).on('click', '#pagination a.page-no', function() {
            var current = this.text.trim();
            Cpage = "vp_" + (current);
            clearQueryParams();
            scanOmniVars(true);
            window.location.hash = Cpage;
            var VPpageVal = Cpage.split("_");
            var trackingObj = {};
            trackingObj['CPage'] = VPpageVal[1];
            trackingObj['nxOrPrvTrk'] = 'ar-nav_num' + current;
            navTracking(trackingObj, current);
        });

        $(window)
            .bind("hashchange", vpHash)
            .trigger("hashchange");
    }

    function clearQueryParams() {
        window.history.replaceState({}, '', window.location.href.split('?')[0]);
    }
    
    if ($("#new-page-nav-text a").length) {
        var current = window.location.pathname.split('_')[1];
        if (current === undefined) {
            current = 1;
        }
        current = parseInt(current);
        Tpages = parseInt($("#new-page-nav-text a").length);

        if ($('.sections-nav').length) {
            if (breakpoint > 1) {
                NPageSet(current);
                $("#new-page-nav-text").html(pagination.paginationJournal(current, Tpages));
            } else {
                $("#new-page-nav-text").hide();
            }
            if (current === 1) {
                $("#previous-section").addClass('inactive-section');
            }
            if (current === Tpages) {
                $("#next-section").addClass('inactive-section');
                $("#next-section a").html('');
            }
        }

        if (!$('.sections-nav').is(':empty') && breakpoint == 1) {
            pageScrollEvents.init();
        }

        $('.qna-render').each(function() {
            if ($(this).attr('data-render') === 2) {
                for (var i = current; i <= Tpages; i++) {
                    $("#new-page-nav-text a.page-no").eq(i).addClass("inactive-section");
                }
                $("#next-section").addClass('qna-inactive-section');
            }
        });

    }

    if (breakpoint === 1 && !$('.sections-nav').length) {
        $("#pagination").remove();
    }

    $(document).on('click', '.close-modal', function() {
        var div = $(this).parents('.modal-layer').attr("id");
        hideModal(div);
    }).on('click', '#article-tab', function() {
        if (breakpoint <= 2) {
            var windowOneThrid = $(window).height() * .33;
            var thisTop = $(this).offset().top - $(window).scrollTop();
            if (thisTop >= windowOneThrid) {
                // $('html,body').animate({scrollTop: $('.action-items').offset().top + 15}, 300, navHeight(thisTop));
            }
            if (!$("body").hasClass("refmenushow")) {
                $('body').addClass("refmenushow");
                $('#article-tab').addClass("open");
            } else {
                $('body').removeClass("refmenushow");
                $('#article-tab').removeClass("open");
            }
            navHeight(thisTop);
            wmdPageLink('cr-nav_open');
        }
    });

    if (Medscape.ArticlePage.type == "DEFAULT" || Medscape.ArticlePage.type == "RECAP" || Medscape.ArticlePage.type == "FAST_FIVE") {
        //moving hidden widgets into appropriate places
        var $actionItems = $('.action-items');
        if (isUserLogged){
            $('.action-items, .email-alert-wrap').appendTo($('.js-toolbar:not(.indiscussion-toolbar)').first());
            if (Medscape.ArticlePage.type == "RECAP" && window._isIndiscussion) {
                $('.action-items .share, .action-items .social').appendTo($('.js-toolbar.indiscussion-toolbar'));
                $('.indiscussion-toolbar .share, .indiscussion-toolbar .social').wrapAll('<div class="action-items"></div>');
                if ($('.email-alert-wrap').length > 0) $('.email-alert-wrap').clone().appendTo($(".toolbar-container .toolbar")); // appending to below article toolbar
            }
        }

        //toolbar 
        $(document).on('click', ".share-layer .facebook", function() {
            fburl();
        }).on('click', ".share-layer .twitter", function() {
            twiturl();
        }).on('click', ".share-layer .linkedin", function() {
            linkedinurl();
        }).on("click", '.share-layer .whatsapp', function() {
            whatsappurl();
        }).on('click', ".action-items .print", function() {
            printArticle(canonicalURL);
            wmdPageLink('ar-top_print');
        }).on('click', ".action-items .email", function() {
            wmdPageLink('ar-share_email');
        });

        displaySocialIcons();

		// PPE-341979 - Sticky Sharebar
		$(window).on('scroll', function() {
            // Stickiness starts after passing '.title-area'
            var scrolledPastSocial = false;
            var extraLayerHeight = 0;
            if (window._isODP) {
                if ($('.persistant-video').length > 0) extraLayerHeight = $('.persistant-video').height(); // Docked player height
                scrolledPastSocial = ($('.article-wrapper .title-area').offset().top - window.pageYOffset - 20 - extraLayerHeight <= 0);
            }
            else scrolledPastSocial = (($('.title-area').offset().top + $('.title-area').height()) - window.pageYOffset <= 0);
            // Stickiness ends after passing '.article-wrapper'
            var socialHitBottom = (window.pageYOffset + $('.action-items:eq(0)').height() >= $('.info-layers').offset().top - (window._isODP ? 20 + extraLayerHeight : 100));

            if (scrolledPastSocial && !socialHitBottom && !$('.action-items:eq(0)').hasClass('sticky')) { // If scrolled past social sharebar (and not at bottom yet), start sticking
                $('.action-items:eq(0)').addClass('sticky');
            }
			else if (socialHitBottom && $('.action-items:eq(0)').hasClass('sticky')) { // If bottom is reached, stop sticking
				$('.action-items:eq(0)').removeClass('sticky');
			}
			else if (!scrolledPastSocial && !socialHitBottom && $('.action-items:eq(0)').hasClass('sticky')) { // If near top of page, stop sticking
				$('.action-items:eq(0)').removeClass('sticky');
			}			
		});

		//add email alerts
		$(".add-email-alerts").hide();
		$(".alert-tooltip").hide();
		if(typeof conceptId !== "undefined" || typeof sectionId !== "undefined") {
			$(".add-email-alerts").show();
			addAlerts.init()
			$(document).on("mouseenter", ".email-alert-wrap .not-added", function () {
				$(".alert-tooltip").show();
			}).on("mouseleave", ".email-alert-wrap .not-added", function () {
				$(".alert-tooltip").hide();
			});
		}

        $(document).on("viewportChange", function() {
            displaySocialIcons();
        });
    } // end Medscape.ArticlePage.type == "DEFAULT"
    
    $(document).on('click', '.fyre-flag-link', function(e) {
        e.preventDefault();
        if ($('#comments-layer .fyre-modal').length === 0) {
            $('.fyre-modal').appendTo($('#comments-layer'));
        }
        $('.fyre-modal').offset({ top: $(this).offset().top, left: $(this).offset().left });
    }).on('click', '.close-modal-eq', function() {
        if ($('.modal-layer-eq').length) {
            $('.modal-layer-eq').remove();
        }
    });

    lazyloadingImages.init();

    //Temporary hack for inline references with ranges
    $("a[onclick*='showToolTip']").each(function() {
        var attr = $(this).attr("onclick");
        if (attr.indexOf("–") !== -1 || attr.indexOf("-") !== -1) {
            attr = attr.replace(/–|-/g, ".");
            $(this).attr("onclick", attr);
        }
    });

    //Temporary hack for large tables
    $("table[class='inline_data_table']").each(function() {
        $(this).wrap("<div class='table-content'></div>");
    });

    //equations - for legacy 
    $('.equation, span.imageContainer>img').each(function() {
        if (this.naturalHeight >= 30 || this.naturalWidth >= 300) {
            $(this).addClass("equation-enlarge");
        }
    });

    $(document).on('click', '.equation-enlarge', function(e) {
        var img = $(this).attr("src");
        var $modal = $('<div class="modal-layer-eq"><div class="modal-header-eq"><div class="close-modal-eq"></div></div><div class="modal-content-eq"><img src=' + img + '></div></div>');
        $("body").append($modal);
        $(".modal-layer-eq").css('top', e.pageY);
        if (breakpoint > 2)
            $(".modal-layer-eq").css('left', $(this).offset().left);
        if (breakpoint <= 2 && this.naturalWidth > $(".article-wrapper").width())
            $(".modal-header-eq").append('<div class="scroll-text">< Scroll ></div>');
    });

    $(document).on('click', '.li_references a, .layer-references a', function() {
        showModal('references', this);
		var refLayer = $('#references .modal-content');
		if (typeof mscpA2A == 'boolean' && mscpA2A && $('.inf-art-wrap').length > 0) {
			refLayer = $(this).parents('.inf-art-wrap').find('[id*="references"] .modal-content');
		}
        if (refLayer.is(':empty'))
            loadReferences.init(this);
    });	

	var currLazyArt = null;
	
	document.addEventListener('switchContent', function(e) {
		// $('#references .modal-content').html('');
        // Add Top Picks
		currLazyArt = document.querySelector('.inf-art-wrap[data-contenturl="' + currSlctCont + '"]');
        if (currLazyArt.querySelector('[id*="ads-pos-904"]') != null) {
			if (currLazyArt.querySelector('[id*="top-pick"]') == null) {
				currLazyArt.querySelector('[id*="ads-pos-904"]').insertAdjacentHTML('beforebegin','<div id="top-pick">TOP PICKS FOR YOU</div>');
			}
			window.removeEventListener('scroll', showToppicksScroll);
			window.addEventListener('scroll', showToppicksScroll);
		}
	});
	
	document.addEventListener('a2aInit', function() {
		currLazyArt = document.querySelector('.inf-art-wrap[data-contenturl="' + currSlctCont + '"]');
		if (currLazyArt.querySelector('[id*="ads-pos-904"]') != null) {
			window.addEventListener('scroll', showToppicksScroll);
		}
	});
	
	var pickScrlTimer;
	function showToppicksScroll(e) {
		clearTimeout(pickScrlTimer);
		pickScrlTimer = setTimeout(showToppicks, 150);
	}
	
    function showToppicks() {
		var topPickAds = currLazyArt.querySelectorAll('[id*="ads-pos-904"], [id*="ads-pos-906"], [id*="ads-pos-907"]');
		var anyPickVis = false;
		topPickAds.forEach(function(elem) {
			if (elem.children.length > 0 && elem.children[0].children.length > 0 && !elem.classList.contains('blank-ad') && elem.offsetHeight > 0) {
				anyPickVis = true;
			}
		});
		if (anyPickVis) {
			currLazyArt.classList.add('has-top-picks');
			window.removeEventListener('scroll', showToppicksScroll);
		}
    }

    $('body').click(function(e) {
        if (e.target.className !== "tooltip_link") {
            $('.tooltip').remove();
        }
    });

    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        document.body.addEventListener('touchend', function(e) {
            var touchobj = e.changedTouches[0];
            var ct = $(touchobj.target).attr("class");
            if (ct !== "tooltip_link") {
                $('.tooltip').remove();
            }
        });
    }

    contentGreyBox.init(); //hack for content-grey-box

    flashvid.init();

    if(window.location.search.indexOf("ecd=conmkt") === -1){
        relatedLinks.init();
    } else {
        $("#rel-links-container, #rel-recommend").remove();
    }
    if(Medscape.ArticlePage.type == "DEFAULT"){
		if(Medscape._isODP){
            cpArticleLoad('mdp');
        } else if(armsLengthVariants.includes(PageMetadata.pageSegVars.ctype)) {
            cpArticleLoad('armslength');
        }
        else{
                cpArticleLoad('viewarticle');
        }
    }

    if (Medscape.ArticlePage.type == "DEFAULT" && typeof qna !== 'undefined') {
        qna.init();
    }

    $(document).one('dfpRenderComp', function() {
        coeFooter();
    });

    function checkAuthUser() {
        const authCode = s_auth_channel_id !== 'undefined' ? s_auth_channel_id : "";
        if (typeof s_registered_user_id !== 'undefined' && authCode && (authCode === "103-2" || authCode === "104-2" || authCode === "105-2" || authCode === "107-2" || authCode === "108-2")) {
            return "logged-in";
        }
        else if (typeof s_registered_user_id !== 'undefined' && authCode && (authCode === "101-1" || authCode === "102-1")) {
            return "logged-out";
        }
        else {
            return "anonymous";
        }
    }

	// Append Like before Commenting
    if (Medscape.ArticlePage.type == "DEFAULT" || Medscape.ArticlePage.type == "RECAP" || Medscape.ArticlePage.type == "FAST_FIVE") {
        if ($(".js-toolbar:not(.indiscussion-toolbar) .action-items").length == 0) {
            $('.js-toolbar:not(.indiscussion-toolbar)').first().append('<div class="action-items"></div>');
        }    
        let iconsToAppend = [];
        if (Medscape.ArticlePage.type == "DEFAULT" || $('.page-body.clinical-lens').length > 0) {
            iconsToAppend = [
                ['.js-toolbar .action-items', 'div'],
                ['.info-layers ul', 'li']
            ]
        }
        else if ((Medscape.ArticlePage.type == "RECAP" && !window._isIndiscussion) || Medscape.ArticlePage.type == "FAST_FIVE") {
            iconsToAppend = [
                ['.js-toolbar .action-items', 'div'],
                ['.toolbar-container .js-toolbar', 'div']
            ]
        }
        else if (Medscape.ArticlePage.type == "RECAP" && window._isIndiscussion) {
            iconsToAppend = [
                ['.js-toolbar:not(.indiscussion-toolbar) .action-items', 'div'],
                ['.toolbar-container .js-toolbar', 'div']
            ]
        }
		window.likesConfig = {
			'trackVal': 'ar-cont',
			'iconsToAppend': iconsToAppend
		}		
		$('body').append('<link rel="stylesheet" href="//img.' + getDomain() + 'medscapestatic.com/medscape-core/common/css/global/likes.css" type="text/css" />');
		var likeJs = document.createElement('script');
		likeJs.setAttribute('defer','');
        likeJs.onload = function (evt) {
            if (Medscape.ArticlePage.type == "RECAP" && window._isIndiscussion) {
                let likeEles = document.querySelectorAll('.js-toolbar .like');
                let authUser = checkAuthUser();
                // Append Like before Commenting
                [...likeEles].forEach((likeEle) => {
                    if (authUser == 'anonymous' && $(likeEle).children('.like-count').text()) {
                        $(likeEle).addClass('active');
                    }
                })
            }
        }
		likeJs.src = '//img.' + getDomain() + 'medscapestatic.com/medscape-core/common/js/likes/likes.js';
		document.body.appendChild(likeJs);
	}
	
	// Append Commenting Icon
	appendCommentIcon();

	// tracking for D&D cross-linking
	$("a[class^='cl_ref_article_']").on("click", function() {
		wmdTrack("embd-arlnk",this);
	});

	$("a[class^='cl_ref_drugs_']").on("click", function() {
		wmdTrack("embd-drlnk",this);
	});
	
	embedTweets();
	
	function initMobAdOptimize() {
		if (window.textDriverOptimized && (_isAnArticle || isEmed)) { // PPE-195473, PPE-200057
			$('body').addClass('mbl-opt');
		}
	}
	initMobAdOptimize();
	document.addEventListener('switchContent', initMobAdOptimize);
	
    if(webmd.ads2.display === undefined) return; // ad blocker check
    if (location.hash.indexOf('transcript') !== -1 || location.hash.indexOf('guidelines') !== -1) {
        webmd.ads2.display();
        webmd.ads2.refresh();
    }
    $(document).one('dfpRenderComp', function() {
        overlapfix();
    });

    //checks to see if query string is 'icd'
    const icd = getParameterByName("icd");
    if(icd) {
        //check to see if links are external or internal
        $( 'a' ).each(function() {
            if( location.hostname === this.hostname || !this.hostname.length ) {
                $(this).addClass('icdLocalLink');
            } else {
                $(this).addClass('icdExternalLink');
            }
        });
        const anchors =  document.getElementsByClassName('icdExternalLink');
        //add base tag to each external anchor so links open in new tab
        for (let i = 0; i < anchors.length; i++) {
            anchors[i].setAttribute('target', '_blank');
        }
        //add icd value as class
        $("body").addClass(icd + "-driver");
    }

    // Instream recirc logic
    if(vpt == 'false'){
        if(_isAnArticle && !_isFFQ){
            addinsertInstreamRecirc();
        }
    }
    else{
        if(_isAnArticle && !_isFFQ && document.location.hash === ""){
            addinsertInstreamRecirc();
        }
    }
	
	document.addEventListener('switchContent', function(e) {
		window.scrollInstreamRecirc = false;
		addinsertInstreamRecirc();
	});
	
    // Instream recirc logic
    //load any thumbnails in view on load
    lazyloadingImages.resizeOnScroll();

    // Accordion click event handling    
    if ($(".accordion-section").length > 0) {
        //wrap child components into panel
        $(".accordion-wrapper").wrapInner($("<div class='panel'>"));
        $('div.panel').each(function () {
            $(this).children().first().prependTo($(this).closest(".accordion-wrapper"));
        })
        $(document).on('click', '.accordion-wrapper .accordion', function (e) {
            let accrWrapper = $(this).closest('.accordion-wrapper');
            let accrdionHeading =  $(this).children(".accordion .accordion-heading").text();
            let heading = accrdionHeading.replace(/[^\w-]+/g, '-').toLowerCase();
            if ($(accrWrapper).hasClass('active')) {
                $(accrWrapper).removeClass('active');
                wmdPageLink(`al-accordion-${heading}_collapse-${heading}`,this);
            }
            else {
                $(accrWrapper).addClass('active');
                wmdPageLink(`al-accordion-${heading}_expand-${heading}`,this);
            }
            $(this).children('button') && $(this).children('button').remove();
            $('#accordion-model') && $('#accordion-model').remove();
            $('body').css("overflow", "auto")
        })
        if (breakpoint == 1) {
            setStickyAccordion();
        }
    }
    if(_isODP){
        pageLevelTackingLinks("dp","#article-content");
    }
    else if(armsLengthVariants.includes(DFPTargetKeys.pageSegVars.ctype)){
        pageLevelTackingLinks("al","#article-content");
        try {
            window.addEventListener('message', (event) => {
                // Add event listener for message
                if (event.data && typeof event.data == "string" && event.data.indexOf('loadSponsoredPoll') >= 0) {
                    if (Medscape.ArticlePage && Medscape.ArticlePage.createSponsoredPoll) {
                        const config = JSON.parse(event.data);
                        if (config['payload']) {
                            Medscape.ArticlePage.createSponsoredPoll(config['payload']);
                        }
                    }
                }
            });
        } catch (error) {
            console.log(error);            
        }
    }
    else if($("#bodypadding").hasClass('care-cues')){
        pageLevelTackingLinks("ccu","#article-content");
    }
    else if($("#bodypadding").hasClass('in-discussion')){
        pageLevelTackingLinks("ind","#article-content");
    }
    else if($(".page-body").hasClass('fast-five-quiz')){
        pageLevelTackingLinks("ffq","#article-content");
    }
    else if($(".page-body").hasClass('recap')){
        pageLevelTackingLinks("rcpv","#article-content");
        PauseVideoIFIBrandAlert();
    }
    else if($(".page-body").hasClass('recap-text')){
        pageLevelTackingLinks("rcpt","#article-content");
    }
    else if($(".page-body").hasClass('recap-guidance')){
        pageLevelTackingLinks("rcpg","#article-content");
    }
    else if($(".page-body").hasClass('skill-checkup')){
        pageLevelTackingLinks("skch","#article-content");
    }
    else if($(".page-body").hasClass("mdangle")){
        pageLevelTackingLinks("mda", "#article-content")
    }
    else if($(".page-body").hasClass("medscape-medical-minute")){
        pageLevelTackingLinks("mmm", "#article-content")
    }
});

//document.addEventListener('beforePageView', scanPromoKeys());

function vpHash(e) {
    if (location.hash.indexOf('vp_') !== -1 || document.location.hash === "") {
        $("#whiteoutlayer").click();
		if (typeof mscpAbGrp == 'undefined' || !mscpAbGrp) {
			for (var ot = 0; ot < Fpages.length; ot++) {
				$('#pageN_' + pageNs[ot]).hide();
			}
			window.scroll(0, 0);
		}
    }
    if (document.location.hash === "") {
		if (typeof mscpAbGrp == 'undefined' || !mscpAbGrp) {
			for (ot = 0; ot < Fpages.length; ot++) {
				$('#pageN_' + pageNs[ot]).hide();
			}
		}
        $('#pageN_' + 1).show();
        $('#CpageN').html(1);
        //  textDriver.show('1'); reverting brandadvance test
        $('#next-section').html('<a href="javascript:void(0);">' + getNextPageTranslation() + '</a>');
        $('#next-section').removeClass("inactive-section");
        $('#previous-section').addClass("inactive-section");
        Cpage = "vp_1";
        NPageSet(1);
    } else {
        if (location.hash.indexOf('vp_') !== -1) {
            var hash = location.hash.split("_");
			hash[1] = hash[1].split('?')[0];
            if (hash[1] === "" || $('#pageN_' + hash[1]).length !== 1) {
                window.location.hash = "vp_1";
            } else {
                $("a.page-no").removeClass("current-page");
                $("#new-page-nav-text").html(pagination.paginationNews(hash[1], Fpages.length));
                if (hash[1] > Fpages.length) {
                    $('#pageN_' + 1).show();
                    $('#CpageN').html(1);
                    //textDriver.show('1'); reverting brand advance test
                    $('#next-section').html('<a href="javascript:void(0);">' + getNextPageTranslation() + '</a>');
                    $('#next-section').removeClass("inactive-section");
                    $('#previous-section').addClass("inactive-section");
                    Cpage = "vp_1";
                    NPageSet(1);
                } else {
                    if (hash[1] == 1) {
                        $('#pageN_' + 1).show();
                        $('#CpageN').html(1);
                        //textDriver.show('1'); reverting brand advance test
                        $('#next-section').html('<a href="javascript:void(0);">' + getNextPageTranslation() + '</a>');
                        $('#next-section').removeClass("inactive-section");
                        $('#previous-section').addClass("inactive-section");
                        Cpage = "vp_1";
                        NPageSet(1);
                    } else {
                        //  textDriver.show(hash[1]); reverting brand advance test
                        if (hash[1] < Fpages.length) {
                            $('#pageN_' + hash[1]).show();
                            $('#CpageN').html(hash[1]);
                            $('#next-section').html('<a href="javascript:void(0);">' + getNextPageTranslation() + '</a>');
                            $('#next-section').removeClass("inactive-section");
                            $('#previous-section').removeClass("inactive-section");
                            Cpage = "vp_" + hash[1];
                            NPageSet(parseInt(hash[1]));
                        } else {
                            $('#pageN_' + hash[1]).show();
                            $('#CpageN').html(hash[1]);
                            $('#next-section').html('<a href="">&nbsp</a>');
                            $('#next-section').addClass("inactive-section");
                            $('#previous-section').removeClass("inactive-section");
                            Cpage = "vp_" + hash[1];
                            NPageSet(parseInt(hash[1]));
                        }
                    }
                }
            }
        } else {
            if (location.hash.indexOf('page') === -1) {
                $('#pageN_' + 1).show();
                $('#CpageN').html(1);
                //  textDriver.show('1'); reverting brandadvance test
                $('#next-section').html('<a href="javascript:void(0);">' + getNextPageTranslation() + '</a>');
                $('#next-section').removeClass("inactive-section");
                $('#previous-section').addClass("inactive-section");
                Cpage = "vp_1";

                NPageSet(1);
            }
        }
        console.log("Inside vpHash method");
        if(_isAnArticle && !_isFFQ){
            $("#instream-recirc").remove();
            window.scrollInstreamRecirc = false;
            addinsertInstreamRecirc();
        }
    }
	/* if (typeof mscpAbGrp != 'undefined' && mscpAbGrp && hashPos === 0) {
		if (Number(Cpage.split('_')[1]) > 1) {
			$(window).on('load', function() {
				$('#pageN_' + Cpage.split('_')[1])[0].scrollIntoView();
			});
		} else {
			window.scroll(0, 0);			
		}
	} */
    if (location.hash.indexOf('vp_') !== -1 && (hashPos === 0)) {
        hashPos = 1;
        var VPpageVal = Cpage.split("_");
        DesktopAdMove.adHashInit(Number(VPpageVal[1]));

    } else if (hashPos === 0) { // ensure hashPos changes after inital load.
        hashPos = 1;
    }
}

/* Scroll Events*/
var pageScrollEvents = {
    init: function() {
        this.articleNavWrapHt = $('#article-nav-wrap').height(),
            this.articleNavWrapTop = $('#article-nav-wrap').offset().top,
            this.articleTabTop = $('#article-tab').offset().top;
        $(window).on('scroll', function() {
            pageScrollEvents.stickyNav();
        });
        return this;
    },
    stickyNav: function() {
        if ($(window).scrollTop() >= this.articleTabTop - 6 && $(window).scrollTop() <= $('.mobile-sections-nav').offset().top - 100) {
            $('#article-nav').addClass("fixed-sticky");
            $('.article-content').css({ "margin-top": this.articleNavWrapHt + "px" })
        } else {
            $('#article-nav').removeClass("fixed-sticky");
            $('.article-content').css({ "margin-top": "0" })
        }
        return this;
    }
}

/* End Scroll Events*/

/* lazy-loading & resizing of images */
var lazyloadingImages = {
    datasrc: "",
    imgWidth: "",
    init: function(contUrl) {
        let imgSel = document.querySelectorAll('img[data-src]');
        if(contUrl) {
            imgSel = document.querySelectorAll('.inf-art-wrap[data-contenturl="' + contUrl + '"] img[data-src]');
        }
        imgSel.forEach(function(elem) {
            let dataSrc = elem.getAttribute("data-src");
            if (elem.parentNode.classList.contains("badge") || elem.parentNode.classList.contains("partner-badge")) {
                lazyloadingImages.badgeResize(dataSrc, $(elem));
            } else if ($(elem).parents(".modal-content").length > 0) {
                lazyloadingImages.modalWindowResize(dataSrc, $(elem));
            } else {
                elem.classList.add('resizeImage');
            }
        });
        $(window).on("scroll", lazyloadingImages.resizeOnScroll);
    },
    badgeResize: function(dataSrc, _this) {
        _this.attr("src", dataSrc + "?interpolation=lanczos-none&resize=*:85");
    },
    modalWindowResize: function(dataSrc, _this) {
        _this.attr("src", dataSrc);
    },
    imageResize: function(dataSrc, _this) {
        imgWidth = _this.attr("data-width");
        totalWidth = $("#article-content").width();
        contentFigImgWidth = totalWidth;
        if (imgWidth === undefined || isNaN(imgWidth)) { //hack for imgs not having data-attributes
            if (breakpoint <= 2) {
                _this.css('max-width', contentFigImgWidth);
                _this.height("auto");
            }
            _this.attr("src", dataSrc);
        } else if (document.querySelector('link[rel=preload][as=image]') != null && document.querySelector('link[rel=preload][as=image]').href == dataSrc) {
			_this.attr("src", dataSrc);
		} else if (breakpoint <= 2 && imgWidth > totalWidth && contentFigImgWidth*2 < imgWidth) {
            _this.attr("src", dataSrc + "?interpolation=lanczos-none&resize=" + contentFigImgWidth*2 + ":*");
        } else {
            _this.attr("src", dataSrc + "?interpolation=lanczos-none&resize=" + imgWidth + ":*");
        }

    },
    resizeOnScroll: function() {
        $('.resizeImage').each(function () {
            if (scrollEvents.scrollIntoView($(this))) {
                lazyloadingImages.imageResize($(this).attr('data-src'), $(this));
                $(this).removeClass('resizeImage');
            }
        });
        if ($('.resizeImage').length == 0) {
            $(window).off("scroll", lazyloadingImages.resizeOnScroll);
        }
    }
}
/* end lazy-loading & resizing of images */

/* Video Player */
var flashvid = {
    flashvidsize: 690,
    init: function() {
        this.$flashvid = $("#videoContent");
        this.$flashvidcontainer = $(".flashvidcontainer");
        this.$html5vidbox = $(".html5vidbox");
        this.$video = this.$html5vidbox.find("video");
        var self = this;
        var showflash = false;

        // disable the video from preloading
        this.$video.attr("preload", "none");

        //check when size of container to do a switch
        $(window).resize(function() {
            var curshowflash = self.$flashvid.width() >= self.flashvidsize;
            if (curshowflash !== showflash) {
                showflash = curshowflash;
                self.switchPlayer(showflash);
            }
        });

        return;
    },

    switchPlayer: function(showflash) {
        if (showflash) { // show the flash video
            this.$html5vidbox.hide();
            this.$flashvidcontainer.show();
            if (this.$video[0]) {
                this.$video[0].pause();
            } // pause the video if it's playing
        } else { // show the html5 video
            this.$flashvidcontainer.hide();
            this.$html5vidbox.show();
        }
    }
};
/* End Video Player */

/* hack for content-grey-box */
var contentGreyBox = {
    init: function() {
        this.leftDiv = $("div[align='left']");
        this.nextEle = $("div[align='left'] + table.inline_data_table");
        contentGreyBox.manipulateHtml();

    },
    manipulateHtml: function() {
        $(this.nextEle).each(function() {
            this.leftDiv.wrap('<div class="content-grey-box"/>').parent().prepend(nextEle)
        });
        $(".content-grey-box>.inline_data_table>tbody").first().remove();
    }
}
/* end hack for content-grey-box */

function closeShareLayer() {
	if (Medscape._isODP) {
		$(".toolbar.js-toolbar").removeClass("dp-share-mobile");
		$(".action-items .social").css('display', 'none');
	} else {
		$(".action-items .social").css('display', 'none');
	}
	$(document).off('touchstart', shareClickAway);
}

function shareClickAway(e) {
	if (!$(e.target).hasClass('share-layer') && $(e.target).parents('.share-layer').length == 0) {
		closeShareLayer();
	}
}

function displaySocialIcons() {
	if (!Medscape._isODP) {
		$(".action-items .social").css('display', 'none');
	}    
	$(document).on('mouseenter touchstart', '.action-items .share', function() {		
		$(".action-items .social").css('display', 'inline-block');
		$(document).on('touchstart', shareClickAway);
	});
	$(document).on('mouseleave', '.action-items', closeShareLayer);
}

// Adding Coe footer Ad event listener
coeFooterEventEnable();

/* Modal Layers */
function showModal(contentId, elem) {
	
	if (typeof elem == 'object' && $('.inf-art-wrap').length > 0) {
		var layerElem = $(elem).parents('.inf-art-wrap').find('[id*="' + contentId + '"]')[0];
		contentId = layerElem.id;
	}

    if (breakpoint <= 2) {
        tempScrollTop = $(window).scrollTop();
    }

    $("body").addClass("modal-layer-on");

    if (breakpoint === 1) {
        $('body').removeClass("refmenushow");
        $('#article-tab').removeClass("open");
    } else {
        $("#" + contentId).css({ 'position': 'absolute' });
        movelayers(contentId);
    }

    $("#" + contentId).removeClass("inactive");
    $("#" + contentId).addClass("active");
    $("#whiteoutlayer").css({ 'display': 'block' });

    if ((navigator.userAgent.indexOf('iPad') !== -1) && contentId != 'palertadexcontainer') {
        $("#whiteoutlayer").css({ 'position': 'absolute', 'top': "0", "height": document.body.scrollHeight });
        $('body.modal-layer-on').css({ 'position': 'fixed', 'top': -Math.abs(tempScrollTop) });
    } else {
        $("#whiteoutlayer").css({ 'position': 'fixed', 'top': '0' });
    }
}

function hideModal(contentId) {
    $('[id*="' + contentId + '"]').addClass("inactive");
    $('[id*="' + contentId + '"]').removeClass("active");

    if ($('body').hasClass("modal-layer-on") && !$(".modal-layer").hasClass("active")) {
        $("body").removeClass("modal-layer-on");
        $('[id*="' + contentId + '"]').css({ 'position': '' });
        $('[id*="' + contentId + '"]').css({ 'top': '' });
        $("#whiteoutlayer").hide();

        if ((navigator.userAgent.indexOf('iPad') !== -1)) {
            $('body').css({ 'position': 'static', 'top': '' });
        }

        if (breakpoint <= 2) {
           // $(window).scrollTop(tempScrollTop);
        }
    }
}

function showToolTip(_this, contentId, refId) {
    if ($('.tooltip').length) {
        $('.tooltip').remove();
    }
	
	if ($('.inf-art-wrap').length > 0) {
		contentId = $(_this).parents('.inf-art-wrap').find('[id*="' + contentId + '"]')[0].id;
	}

    if ($('#' + contentId + ' .modal-content').is(':empty')) {
        var deferred = loadReferences.init(_this);
        $.when(deferred).done(function() {
            showToolTip(_this, contentId, refId)
        });
    }

    $(_this).addClass("tooltip_link");

    //Temporary hack for inline references with ranges
    if (refId % 1 !== 0) {
        showModal(contentId, _this);
    }

    var ref = ($('#' + contentId + ' .modal-content li').eq(refId - 1).html());

    if (ref === undefined) {
        showModal(contentId, _this);
    }

    var tooltip_text = ref;
    $(_this).append('<div class="tooltip">' + tooltip_text + '</div>');

    if (breakpoint <= 2) {
        var wdTwoThrid = $(window).width() * .66;
        var wdOneThrid = $(window).width() * .33;
        if ($(_this).offset().left >= wdTwoThrid) {
            $(".tooltip").css("right", -21);
        } else if ($(_this).offset().left > wdOneThrid && $(_this).offset().left < wdTwoThrid) {
            $(".tooltip").css("right", -128);
            $(".tooltip").addClass("posCenter");
        } else {
            $(".tooltip").css("left", -21);
            $(".tooltip").addClass("posRight");
        }
    } else {
        $(".tooltip").css("right", -128);
        $(".tooltip").addClass("posCenter");
    }
    wmdPageLink('ar_refs');
}

function printArticle(canonicalURL) {
    let printUrl = location.pathname.split("_")[0];
    window.open(printUrl + '_print', 'articleprintwin', 'scrollbars=1,resizable=1,width=760,height=440');
    socialCp("print");
}

/* For ellipsis in first nine pages */
function NPageSet(pageNo) {
    $('a.page-no').each(function() {
        if (parseInt($(this).text()) === pageNo) {
            $(this).addClass("current-page");
        }
    });
}

/* pagination */
var pagination = {
    paginationNews: function(current, size) {
        this.step = 2;
        this.code = "";
        this.current = parseInt(current);

        if (size <= this.step * 2 + 1) {
            this.code += this.addPageNews(1, size + 1);
        } else if (this.current < this.step * 2) {
            this.code += this.addPageNews(1, this.step * 2 + 1);
            this.code += '...<a href="javascript:void(0);" class="page-no">' + size + '</a>'
        } else if (this.current > size - this.step * 2 + 1) {
            this.code += '<a href="javascript:void(0);" class="page-no">1</a>...';
            this.code += this.addPageNews(size - this.step - 1, size + 1);
        } else {
            this.code += '<a href="javascript:void(0);" class="page-no">1</a>...';
            this.code += this.addPageNews(this.current - this.step + 1, this.current + this.step);
            this.code += '...<a href="javascript:void(0);" class="page-no">' + size + '</a>'
        }
        return this.code;
    },

    addPageNews: function(start, finish) {
        this.noOfPages = "";
        for (var i = start; i < finish; i++) {
            this.noOfPages += '<a onclick="wmdTrack(\'ar-nav_nx' + i + '\');" href="javascript:void(0);" class="page-no">' + i + '</a>';
        }
        return this.noOfPages;
    },

    paginationJournal: function(current, size) {
        this.step = 2;
        this.code = "";
        this.current = current;

        if (size <= this.step * 2 + 1) {
        } else if (this.current < this.step * 2) {
            this.addPageJournal(this.step * 2 + 1, size);
            $('a.page-no:nth-child(' + parseInt(size - 1) + ')').before('...');
        } else if (this.current > size - this.step * 2 + 1) {
            this.addPageJournal(this.step, size - this.step * 2 + 1);
            $('a.page-no:nth-child(' + parseInt(size - this.step * 2) + ')').before('...');
        } else {
            this.addPageJournal(this.step, this.current - 1);
            $('a.page-no:nth-child(' + parseInt(this.current - this.step) + ')').before('...');
            this.addPageJournal(this.current + this.step, size);
            $('a.page-no:nth-child(' + parseInt(this.current + this.step - 1) + ')').after('...');
        }
    },

    addPageJournal: function(start, finish) {
        for (var i = start; i < finish; i++) {
            $("a.page-no").eq(i - 1).hide();
        }
    }
}
/* End pagination */

// get the Translation of the words "Next Page"
function getNextPageTranslation() {
    if (locale === "fr") {
        return "Suivant";
    } else if (locale === "de") {
        return "Weiter";
    } else if (locale === "es") {
        return "Siguiente";
    } else if (locale === "pt") {
        return "Página seguinte";
    } else {
        return "Next";
    }
}

/* Load References */
var loadReferences = {
    init: function(elem) {
        this.refContainer = $('#references .modal-content');
        this.articleUrl = [location.protocol, '//', location.host, location.pathname].join('').split('_')[0];
		if (typeof elem == 'object' && $('.inf-art-wrap').length > 0) {
			this.refContainer = $(elem).parents('.inf-art-wrap').find('[id*="references"]').find('.modal-content');
			this.articleUrl = $(elem).parents('.inf-art-wrap').attr('data-contenturl');
		}
        this.refContainer.html("<div class='spinner'></div>");
        this.ajaxCall();
    },
    ajaxCall: function() {
        $.ajax({
            type: "GET",
            url: this.articleUrl + "_reference",
            async: false,
            dataType: "html",
            success: function(data) {
                loadReferences.addReferences(data);
            }
        });
    },
    addReferences: function(data) {
        this.refContainer.html(data);
    }
}
/* End Load References */

// get the appropriate class name/translation for the "likes" on commenting
// The first value for the array is for singular "like" and the second is for multiple "likes"
function getLikesClassNames() {
    if (locale === "fr") {
        return ["likeTextFR", "likeTextPluralFR"];
    } else if (locale === "de") {
        return ["likeTextDE", "likeTextPluralDE"];
    } else if (locale === "es") {
        return ["likeTextES", "likeTextPluralES"];
    } else if (locale === "pt") {
        return ["likeTextPT", "likeTextPluralPT"];
    } else {
        return ["likeText", "likeTextPlural"];
    }
}

function navHeight(thisTop) {
    var windowHeight = $(window).height();
    var navHeight;
    if (thisTop === 0)
        navHeight = windowHeight - 80; //30px from bottom + height of sectionTab
    else
        navHeight = windowHeight - 156; //30px from bottom + height of sectionTab + top offset
    $("#menuWrapper").css({ "max-height": navHeight + "px" });
}

/* Utility Function Move Layers */
function movelayers(num) {
    if (window.innerHeight) {
        pos = window.pageYOffset
    } else if (document.documentElement && document.documentElement.scrollTop) {
        pos = document.documentElement.scrollTop
    } else if (document.body) {
        pos = document.body.scrollTop
    }

    if (pos < theTop) {
        pos = theTop;
    } else {
        pos += 50;
    }

    if (pos == old) {
        document.getElementById(num).style.top = (pos + 'px');
    } else {
        old = pos;
        movelayers(num);
    }
}

/**Commenting**/

function appendCommentIcon() {
	if (typeof vfUuid != 'undefined' && typeof PageMetadata != 'undefined' && typeof PageMetadata.pageSegVars != 'undefined' && typeof PageMetadata.pageSegVars.art != 'undefined') {
		if (Medscape.ArticlePage.type == "DEFAULT" || Medscape.ArticlePage.type == "RECAP" || Medscape.ArticlePage.type == "FAST_FIVE") {
			if ($(".js-toolbar:not(.indiscussion-toolbar) .action-items").length == 0) {
				$('.js-toolbar:not(.indiscussion-toolbar)').first().append('<div class="action-items"></div>');
			}
			$(".js-toolbar:not(.indiscussion-toolbar) .action-items").prepend('<div class="comment-count hasComments" onclick="initComments();"><span class="viafoura-commentcount comment-number" data-vf-article-id="' + PageMetadata.pageSegVars.art + '" data-vf-section-uuid="' + vfUuid + '">0</span></div>');
			if(Medscape.ArticlePage.type == "DEFAULT" || $('.page-body.clinical-lens').length > 0) $(".info-layers ul").prepend('<li class="comment-count hasComments" onclick="initComments();"><span class="viafoura-commentcount comment-number" data-vf-article-id="' + PageMetadata.pageSegVars.art + '" data-vf-section-uuid="' + vfUuid + '">0</span></li>');
            else if(Medscape.ArticlePage.type == "RECAP" || Medscape.ArticlePage.type == "FAST_FIVE")  $(".toolbar-container .toolbar").prepend('<div class="comment-count hasComments" onclick="initComments();"><span class="viafoura-commentcount comment-number" data-vf-article-id="' + PageMetadata.pageSegVars.art + '" data-vf-section-uuid="' + vfUuid + '">0</span></div>');
        }
	}
}


/* LEAVING BLOCK COMMENTED OUT FOR FUTURE REFERENCE ONLY - this Livefyre-based functionality not yet accounted for using Viafoura, need to port it over once solution identified

function addSpecialty() {
    if (getAuthLevel() == 2) {
        var res = $('#livefyre .fyre-comment-wrapper');
        var oneLike = getLikesClassNames()[0];
        var multipleLikes = getLikesClassNames()[1];
        res.each(function(index, value) {
            if ($(value).find('.fyre-user-level').length !== 1) {
                var classList = $(value).attr('class');
                if (classList.indexOf('fyre-comment-author-tag') !== -1) {
                    var updated = classList.split('fyre-comment-author-tag-');
                    var speciality = updated[1].split('-');
                    if (typeof speciality[1] === "undefined") {
                        speciality = updated[1].split('%20');
                    }
                    var disRule = speciality[1] + "Json";
                    if (speciality[2] === "12") {
                        var profNurse = eval("lfConfig.profJson[12]")
                        var _spec = eval("lfConfig.occJson[" + speciality[0] + "]")
                        if (typeof(_spec) !== "undefined") {
                            $('<span class="fyre-user-level">| &nbsp;' + _spec + '</span>').insertAfter($(value).find('.fyre-comment-username'));
                        } else {
                            $('<span class="fyre-user-level">| &nbsp;' + profNurse + '</span>').insertAfter($(value).find('.fyre-comment-username'));
                        }
                    } else {
                        if (speciality[1] === 'spec') {
                            if (speciality[0] === 0) {
                                var _a = eval("lfConfig.profJson[" + speciality[2] + "]")
                            } else {
                                var _a = eval("lfConfig." + disRule + "[" + speciality[0] + "]")
                            }
                            if (typeof(_a) !== "undefined") {
                                $('<span class="fyre-user-level">| &nbsp;' + _a + '</span>').insertAfter($(value).find('.fyre-comment-username'));
                            }
                        } else {
                            var _a = eval("lfConfig." + disRule + "[" + speciality[2] + "]")
                            if (typeof(_a) !== "undefined") {
                                $('<span class="fyre-user-level">| &nbsp;' + _a + '</span>').insertAfter($(value).find('.fyre-comment-username'));
                            }
                        }
                    }
                }
            }
            if ($(value).find('.fyre-comment-like-count').html() !== "") {
                if ($(value).find('.fyre-comment-like-count').html() === "1") {
                    $(value).find('.fyre-comment-like-count').addClass(oneLike);
                } else {
                    $(value).find('.fyre-comment-like-count').addClass(multipleLikes);
                }
            }
            $(value).find('.fyre-comment-like-btn').click(function() {
                if ($(value).find('.fyre-comment-like-count').html() !== "") {

                    if ($(value).find('.fyre-comment-like-count').html() === "1") {
                        $(value).find('.fyre-comment-like-count').addClass(oneLike);
                    } else {
                        $(value).find('.fyre-comment-like-count').addClass(multipleLikes);
                    }
                } else {
                    $(value).find('.fyre-comment-like-count').removeClass(oneLike);
                    $(value).find('.fyre-comment-like-count').removeClass(multipleLikes);
                }
            });
        });

        if (breakpoint <= 2) {
            $(".fyre-comment-actions a").each(function() {
                if ($(this).hasClass("fyre-comment-flag-mobile-btn")) {
                    $(this).attr("class", "fyre-flag-link");
                    $(this).html("<span></span> Flag");
                }
            });
        }

        $("#livefyre .fyre-comment-count").prependTo("#livefyre .fyre-stream-sort");

        //PPE-289272 - Community: Profile Hover
        //only displays for logged in users on english edition articles
        if (locale === 'us') {
            var timer;
            //desktop
            if (breakpoint === 3 || breakpoint === 4) {
                //call profileHover after hovering for 0.25 seconds
                //events need to ub unbound first as addSpecialty is called twice on initial render
                $('.fyre-comment-username').off('hover').hover(
                    function() {
                        $(this).parent().addClass('show-card');
                        var self = this;
                        timer = setTimeout(function() { profileHover($(self).next()) }, 250);
                    },
                    //remove card and clear timeout when no longer hovering
                    function() {
                        $(this).closest('.fyre-comment-head').children('.profile-card').hide();
                        clearTimeout(timer);
                        $(this).parent().removeClass('show-card');
                    }
                );
            }
            //mobile
            else {
                //on click call profileHover
                //change display of greoutlayer so it is visible
                $('.fyre-comment-username').off('click').on("click", function() {
                    $(this).parent().addClass('show-card');
                    profileHover($(this).next());
                    $('#greyoutlayer').show();
                });
            }

            //create greyout layer for mobile view
            if (!$('#greyoutlayer').length) {
                var greyoutlayer = document.createElement('div');
                greyoutlayer.setAttribute('id', 'greyoutlayer');
                $('#livefyre').append(greyoutlayer);
            }
        }
    }
}
*/

/* email alerts */
var addAlerts = {
    checkURLData:"",
    alertType:"",
    init:function() {
        if (typeof sectionId !== "undefined") {
            $('.manageLink[href*="topicalert"]').hide();
            checkURLData = "&sectionId=" + sectionId;
            $(".alert-desc").html("Receive email when new articles are published from");
            $(".alert-topic").html(sectionName);
            $(".patopic").html('"'+sectionName+'"');
            addAlerts.alertType="2";
        } else {
            $('.manageLink[href*="columnists"]').hide();
            checkURLData = "conceptId=" + conceptId;
            $(".alert-desc").html("Receive email when new articles are published on");
            $(".alert-topic").html(conceptName);
            $(".patopic").html(conceptName);
            addAlerts.alertType="1";
        }
        addAlerts.ajxCall();
        //}

    },
    ajxCall:function(){
        $.ajax({
            type:"GET",
            url:"https://profreg."+getDomain('profreg')+"medscape.com/px/columns/checksubscription?"+checkURLData,
            //jsonpCallback:'columnresponse',
            dataType:'jsonp',
            success:function(data) {
                addAlerts.renderHTML(data);
            }
        });
    },
    ajxCallSectionID: function(el,alertId,action){
        $.ajax({
            type:"GET",
            url:"https://profreg."+getDomain('profreg')+"medscape.com/px/columns/"+action+"alert/"+alertId,
            dataType:'jsonp',
            success:function(data) {
                $(el).removeClass("not-added").addClass("added");
                $('.added span').html('Added to Email Alerts');
                if(data.subscriptionFeedback==="subscription_successful"){
                    $("#palertadexcontainer").show();
                    wmdPageLink('alrt-clmn_newsub');
                }
                if(data.subscriptionFeedback==="already_subscribed"){
                    $("#palertadexcontainer").show();
                    wmdPageLink('alrt-clmn_subd');
                }
            }
        });
    },
    ajxCallAdd:function(el,alertId){
        $.ajax({
            type:"GET",
            url:"https://profreg."+getDomain('profreg')+"medscape.com/px/columns/addalert/"+alertId,
            dataType:'jsonp',
            //      jsonpCallback:'columnresponse',
            success:function(data) {                
                showModal("palertadexcontainer");
                $(el).removeClass("not-added").addClass("added");
                $('.added span').html('Added to Email Alerts');

                if(data.subscriptionFeedback==="subscription_successful"){
                    $("#palertadexcontainer").show();
                    wmdPageLink('alrt-topc_newsub');
                }
                if(data.subscriptionFeedback==="already_subscribed"){
                    $("#palertadexcontainer").show();
                    wmdPageLink('alrt-topc_subd');
                }
            }
        });
    },
    renderHTML:function(data){
        if (typeof sectionId !== "undefined" && typeof data.subscriptionCheck['section'] !== 'undefined'){
            if(!data.subscriptionCheck['section']){
                $('.add-email-alerts').addClass('not-added');
            }
            else{
                $('.add-email-alerts').addClass('added');
                $('.added span').html('Added to Email Alerts');
            }
            $(document).on('click','.add-email-alerts',function(){
                $(".alert-tooltip").hide();
                showModal("palertadexcontainer");
                addAlerts.ajxCallSectionID(this,"2/"+sectionId,'add');
            });
        }
        else{
            if (typeof data.subscriptionCheck['topic'] !== 'undefined') {
                if(!data.subscriptionCheck['topic']){
                    $('.add-email-alerts').addClass('not-added');
                }else{
                    $('.add-email-alerts').addClass('added');
                    $('.added span').html('Added to Email Alerts');
                }
                $(document).on('click','.add-email-alerts',function(){
                    $(".alert-tooltip").hide();
                    addAlerts.ajxCallAdd(this,"1/"+conceptId);
                });

            }
        }
        $('#palertadexcontainer').appendTo('.page-body');
    },
    closeLayer:function(){
        $("#palertadexcontainer").hide();
        hideModal("palertadexcontainer");
    }
}
/* end email alerts */

/* related links */
var relatedLinks = {

    init: function() {
        // $("#rel-links").appendTo("#rel-links-container");
        if (!window._ismdAffairs) {
            relatedLinks.addRecommended();
        }
        

        if (Medscape.ArticlePage.type==="DEFAULT" && pageType != null && pageType !== 'journal' && typeof s_user_group != 'undefined' && (s_user_group.trim()) == "Physician" && typeof userCountry != 'undefined' && (userCountry.trim()) == "us" && typeof leadconceptName != 'undefined') {
            $("#consult-link").appendTo("#adcontainer_column-right");
            relatedLinks.consultGeneric();
        } else {
            $('#consult-card').parent().hide();
            $('#consult-link').hide();
        }
        if ( pageType && pageType == "recap guidance" && typeof leadconceptName != 'undefined') {
            const consultContainer = $("#consult-card").parent();
            // Adding consult in place of Recommendations
            if( breakpoint == 1) {
                $("#consult-card.rel-links-card").wrapAll('<div />');
                $(".article-column-left").append(consultContainer.html());
            } else {
                $("#mostPopRight").append(consultContainer.html());
            }
            // hiding consult section
            $("#mostPopRight #rel-recommend").hide();
            relatedLinks.consultGeneric();
        }
        relatedLinks.widgetCollapse();

        if (typeof pageType != 'undefined' && pageType != null && pageType == 'journal' && typeof leadconceptName != 'undefined') {
            var record = $('.rel-links-list#indications-card li').length;
            var lconcenptname = encodeURIComponent(leadconceptName);
            if (record > $('.rel-links-list#indications-card').attr('data-max')) {
                $('.rel-links-list#indications-card li').last().remove();
                url = '//search.' + getDomain() + 'medscape.com/search/?q=' + lconcenptname + '&plr=ref&contenttype=Drugs+%26+Neutraceuticals&page=1';
                $('.rel-links-list#indications-card').append('<div class="more-link"><a onclick="wmdTrack(\'rl-drug_more\')" href=' + url + '>View All Drugs </a></div>');

            }
        }
    },

    addRecommended: function() {
        if (breakpoint == 1) {
            $("#rel-recommend").prependTo(".related-links");
        } else {
            $("#rel-recommend").appendTo("#mostPopRight");
        }
    },

    widgetCollapse: function() {

        if (pageType == "journal") {
            $("#other-journals-card, #indications-card, #news-card").parents(".column-card").filter(function() {
                return ($(this).find("li").length < 3)
            }).hide();
        } else if (pageType == "partner") {
            $("#quiz-card, #indications-card").parents(".column-card").filter(function() {
                return ($(this).find("li").length < 3)
            }).hide();
            $("#news-card").parents(".column-card").filter(function() {
                return ($(this).find("li").length == 0)
            }).hide();
        } else {
            $("#bom-card, #slideshow-card").parents(".column-card").filter(function() {
                return ($(this).find("li").length == 0)
            }).hide();
        }

        $("#recommended-card").parents(".column-card").filter(function() {
            return ($(this).find("li").length == 0)
        }).hide();

        if ($('.related-links .column-card:visible').length == 0) {
            $('#rel-links').hide();
        }

    },

    consultGeneric: function() {
        var csltPgSz = 2;
        var consultCount = 0;
        var csltItemCt = 0;
        var _q = leadconceptName.trim().replace(/\+/g, ' ');
        var _l = $('h1.title').text().trim();
        $.ajax({
            url: '//www.' + getDomain() + 'medscape.com/api/v1/consultservice/consultrelatedlinks',
            dataType: 'json',
            contentType: 'application/json',
            data: '{"tags":"' + encodeURIComponent(_q) + '","query":"' + encodeURIComponent(_l) + '"}',
            type: 'POST',
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true,
            success: function(json) {
                if (json && !$.isEmptyObject(json) && json.StatusCode && json.StatusCode === 200 && typeof json.data === 'object' && !$.isEmptyObject(json.data) && json.data.Items && json.data.Items.length > 0) {
                    consultCount = 0;
                    for (var x = 0; x < json.data.Items.length; x++) {
                        var item = json.data.Items[x];
                        try {
                            if (item.Tags.toLowerCase().match(/(^adverse drug reaction ?,)|(, ?adverse drug reaction ?,)|(, ?adverse drug reaction ?$)/) == null && item.Tags.toLowerCase().match(/(^suppress ?,)|(, ?suppress ?,)|(, ?suppress ?$)/) == null && csltItemCt < csltPgSz) {
                                csltItemCt++;
                                var defaultC = '';
                                if (item.Author.AvatarUrl.indexOf('/anonymous.gif') != -1 || item.Author.AvatarUrl.indexOf('/default.png') != -1 || item.Author.AvatarUrl.indexOf('/Profile-Generic.svg') != -1) {
                                    defaultC = ' default';
                                }
                                if (consultCount === 0) {
                                    $('#consult-card').append('<div class="post-header"><a href="//www.' + getDomain() + 'medscape.com/consult/post?id=' + item.Id + '" onclick="wmdTrack(\'rl-consult_post\')"> <div class="post-user-image"><span><img src="' + item.Author.AvatarUrl.replace(/http:/, 'https:') + '" class="avatar' + defaultC + '" border="0"></span></div><div class="post-user">' + item.Author.DisplayName + '<div class="post-user-credentials">' + item.Author.Properties.Specialty + '</div> </div> </a> <div class="post-date"><a href="//www.' + getDomain() + 'medscape.com/consult/post?id=' + item.Id + '" onclick="wmdTrack(\'rl-consult_post\')">' + relatedLinks.csltTimeP(item.Date) + '</a></div> </div> <a href="//www.' + getDomain() + 'medscape.com/consult/post?id=' + item.Id + '" onclick="wmdTrack(\'rl-consult_post\')" class="title">' + item.Title + '</a><div class="consult-bucket-footer"><a class="consult-discussion" onclick="wmdTrack(\'rl-consult_conc\')" href="//www.' + getDomain() + 'medscape.com/consult?filterby=tag&tag=' + _q + '">Join the Discussion</a></div></div>');

                                    consultCount++;
                                }

                                $('#consult-discussion ul').append('<li><div class="post-header"><a href="//www.' + getDomain() + 'medscape.com/consult/post?id=' + item.Id + '" onclick="wmdTrack(\'rl-consult_post\')"> <div class="post-user-image"><span><img src="' + item.Author.AvatarUrl.replace(/http:/, 'https:') + '" class="avatar' + defaultC + '" border="0"></span></div><div class="post-user">' + item.Author.DisplayName + '<div class="post-user-credentials">' + item.Author.Properties.Specialty + '</div> </div> </a> <div class="post-date"><a href="//www.' + getDomain() + 'medscape.com/consult/post?id=' + item.Id + '" onclick="wmdTrack(\'rl-consult_post\')">' + relatedLinks.csltTimeP(item.Date) + '</a></div> </div> <a href="//www.' + getDomain() + 'medscape.com/consult/post?id=' + item.Id + '" onclick="wmdTrack(\'rl-consult_post\')" class="title">' + item.Title + '</a></li>');
                            } else if (csltItemCt >= csltPgSz) {
                                break;
                            }
                        } catch (e) {
                            console.log(e);
                        }

                    }
                    $('#consult-discussion').append('<div class="consult-bucket-footer"><a class="consult-discussion" onclick="wmdTrack(\'rl-consult_conc\')" href="//www.' + getDomain() + 'medscape.com/consult?filterby=tag&tag=' + _q + '">View All Posts</a></div>');
                }
                if (csltItemCt === 0) {
                    $('.rel-links-card#consult-discussion').remove();
                    $('#consult-card').parent().hide();
                }
            }
        });
        if ($('.rel-links-card#consult-discussion').length > 0) {
            if ($('.rel-links-card#consult-discussion li').length > 2) {
                $('.rel-links-card#consult-discussion li').last().remove();
            }
        }
        var _random = Math.floor((Math.random() * 2));

    },

    csltTimeP: function(utc) {
        var dateOrig = new Date(utc);
        var time = Math.round((new Date().getTime() - dateOrig.getTime()) / 60000);
        if (time > 59 && time < 1440) {
            time = Math.floor(time / 60) + 'h';
        } else if (time > 1439) {
            var dateArr = dateOrig.toString().split(' ');
            time = dateArr[1] + ' ' + dateArr[2];
        } else {
            time = time + 'm';
        }
        return time;
    }
}
/* end related links */

/* (START) Sticky Header 141 Ad */

var stickyHead;
(function($) {
    stickyHead = window.stickyHead || {};
    stickyHead = {
        killStickyHead: '',
        stickySettings: {
            $adtagheader: $("#adtagheader"),
            $headerbox: $("#headerbox"),
            $window: $(window),
            originalTopAdTop: '', //$("#adtagheader").offset().top,
            originalAdHeight: ($("#adtagheader").outerHeight() + 90),
            stopStickyHeight: 1100,
            stopStichyTime: 7000
        },
        init: function() {
            var self = this;
            // Do a check to make sure nobody tries to run init twice,
            if (self.init.flag) {
                return;
            }
            self.init.flag = true;

            // hardcode a default height for now to prevent the sticky jumpiness if user scrolls.
            // Also, use timeout to get the original value if the header is not sticky yet
            stickyHead.stickySettings.originalTopAdTop = 104; //$("#adtagheader").offset().top;
            var tmp = setTimeout(function() {
                if ($("#adtagheader").hasClass("stickHeader") == false) {
                    stickyHead.stickySettings.originalTopAdTop = $("#adtagheader").offset().top;
                }
                clearTimeout(tmp);
            }, 1000);

            $(window).on('scroll', stickyHead.stickyHeadscrollHandler);
            webmd.ads2.addSlotRenderEndedCallback("ads-pos-101", function() {
                stickyHead.killStickyHead = setTimeout(function() {
                    if ($("#adtagheader").hasClass("stickHeader")) {
                        stickyHead.animateOffSticky();
                    } else {
                        stickyHead.disableSticky();
                    }
                }, stickyHead.stickySettings.stopStichyTime);
            }); // end addSlotRenderEndedCallback()
        },
        stickyRefresh: function() {
            clearTimeout(stickyHead.killStickyHead);
            $(window).on('scroll', stickyHead.stickyHeadscrollHandler);
            stickyHead.killStickyHead = setTimeout(function() {
                if ($("#adtagheader").hasClass("stickHeader")) {
                    stickyHead.animateOffSticky();
                } else {
                    stickyHead.disableSticky();
                }
            }, stickyHead.stickySettings.stopStichyTime);
            $(document).trigger("stickyRefresh");
        },
        stickyHeadscrollHandler: function() {
            //clearTimeout(stickyHead.killStickyHead);
            var winScrollTop = stickyHead.stickySettings.$window.scrollTop();
            if (winScrollTop > stickyHead.stickySettings.$adtagheader.offset().top) {
                stickyHead.addSticky();
            } else if ($("#adtagheader").offset().top <= stickyHead.stickySettings.originalTopAdTop) {
                stickyHead.removeSticky();
            }
        },
        animateOffSticky: function() {
            stickyHead.disableSticky();
            stickyHead.stickySettings.$adtagheader.slideUp({
                duration: "slow",
                step: function() { $(document).trigger("animateOffStickyStep"); },
                complete: function() {
                    //stickyHead.stickySettings.$adtagheader.slideUp("slow", function () {
                    stickyHead.stickySettings.$adtagheader.hide();
                    stickyHead.stickySettings.$adtagheader.slideDown(function() {
                        stickyHead.stickySettings.$adtagheader.removeClass("stickHeader").addClass("unStickHeader");
                        stickyHead.stickySettings.$headerbox.css({
                            "padding-bottom": "0px"
                        });
                    });
                    stickyHead.stickySettings.$adtagheader.show();
                }
            });
            $(document).trigger("animationOffSticky");
        },
        stickyKillSwitch: function() {
            stickyHead.disableSticky();
            stickyHead.removeSticky();
        },
        disableSticky: function() {
            $(window).off('scroll', stickyHead.stickyHeadscrollHandler);
        },
        addSticky: function() {
            stickyHead.stickySettings.$headerbox.css({
                "padding-bottom": stickyHead.stickySettings.originalAdHeight + "px"
            });
            stickyHead.stickySettings.$adtagheader.removeClass("unStickHeader").addClass("stickHeader");
        },
        removeSticky: function() {
            stickyHead.stickySettings.$adtagheader.removeClass("stickHeader").addClass("unStickHeader");
            stickyHead.stickySettings.$headerbox.css({
                "padding-bottom": "0px"
            });
        }
    };
}($));

/* (END) Sticky Header 141 Ad */

/* (START) Sticky Right Column */
var stickyRightColumn;
(function($) {
    function StickyRightColumn() {
        // sticky settings
        this.stopHeightFromTop = 500; // sticky height setting
        this.howLongRightRailStick = 145; // Accounting for how long right rail sticks
    }

    StickyRightColumn.prototype.init = function(selectorRightColumn, selectorLeftColumn) {
        var self = this;
        this.$window = $(window);
        this.$rightColumn = $(selectorRightColumn); // right rail
        this.$leftColumn = $(selectorLeftColumn); // left rail
        this.$adTagHeader = $("#adtagheader"); // TLB
        this.llcon = $('#ll-container');
        this.scrollHandlerFunc = $.proxy(this.scrollHandler, this); // scroll handler
        if ($("#bodypadding").hasClass('care-cues')) this.scrollHandlerFunc = undefined;
        // trigger this when right rail is fully loaded
        $(window).load(function() {
            // check if kill switch disabled initial scrolling
            if (!self.scrollHandlerFunc)
                return;

            // ensure that the TLB sticky is above the right rail sticky
            self.setScrolling();

            // trigger the scroll in case the page didn't load from the top
            self.$window.trigger("scroll");

            // during resizing of the window make sure the sticky is in the right place
            self.$window.on("resize", function() {
                self.setScrolling();
                self.$window.trigger("scroll"); // jump
            });
        });

        // called during TLB animation off changes
        this.$window.on("animateOffStickyStep", function() {
            self.$window.trigger("scroll");
        });

        // called whenever the size of the LR and RR changes
        this.$window.on("stickyRefresh", function() {
            self.refreshSticky();
        });
        //this.$window.hashchange(function(){ self.setScrolling(); });
        $(document).ajaxComplete(function() {
            self.setScrolling();
        });
    };

    StickyRightColumn.prototype.stickyKillSwitch = function() {
        this.disableSticky();
        this.removeSticky();
        this.scrollHandlerFunc = null;
    };

    StickyRightColumn.prototype.disableSticky = function() {
        $(window).off('scroll', this.scrollHandlerFunc);
    };

    StickyRightColumn.prototype.setScrolling = function() {

        if (!this.scrollHandlerFunc) // check if its been killed
            return;

        // turn off scrolling in case one was on to prevent two adding 2 scrollhandler
        this.disableSticky();
        this.removeSticky();

        // compute boundary conditions
        this.origRightColumnPos = this.$rightColumn.offset(); // get the original (unsticky) pos


        var isRightColumnBigger = this.$leftColumn.outerHeight() - this.howLongRightRailStick < this.$rightColumn.outerHeight();

        // check boundary conditions to determine if scroll handler is needed
        if (isRightColumnBigger) {
            this.$window.off("scroll", this.scrollHandlerFunc);
        } else {
            this.$window.on("scroll", this.scrollHandlerFunc);
        }

        this.$window.trigger("scroll"); // jump

    };

    StickyRightColumn.prototype.refreshSticky = function() {
        this.scrollHandlerFunc = $.proxy(this.scrollHandler, this);
        // set / unset scrolling based on new height settings of the page's right and left columns
        this.setScrolling();
    };

    StickyRightColumn.prototype.scrollHandler = function() {

        var stickyPos = this.getStickyPos();
        var winScrollTop = this.$window.scrollTop();
        if (winScrollTop > this.origRightColumnPos.top - stickyPos) {
            this.addSticky();
        } else {
            this.removeSticky();
        }
    };

    StickyRightColumn.prototype.addSticky = function() {
        if (!this.$rightColumn)
            return;

        var stickyPos = this.getStickyPos();
        var winScrollTop = this.$window.scrollTop();

        var stopHeightTop = $(".md-angle").length > 0 ? 300 : this.stopHeightFromTop;

        var bottomPos = winScrollTop + stickyPos + this.getHeight();

        // compute the bottom position from the top height
        var stopHeightBottom = stopHeightTop + stickyPos + this.getHeight();

        if (bottomPos >= stopHeightBottom) {
            var offset = bottomPos - stopHeightBottom;
            topPos = (stickyPos - offset);
        } else {
            topPos = stickyPos; // either 0 or the height of the header
        }
        this.$rightColumn.css({
            "position": (typeof _isFFQ !== "undefined" && _isFFQ) ? "sticky" : "fixed",
            "top": topPos + "px",
            "z-index": "0"
        });
        if(_isODP || _isFFQ) {
            this.llcon.css({
                "position": "fixed",
                "top": topPos + this.$rightColumn.outerHeight(true) + "px",
                "z-index": "0",
                'width': 'auto'
            });
        }
    };

    StickyRightColumn.prototype.removeSticky = function() {
        if (this.$rightColumn) {
            this.$rightColumn.css({
                "position": "static"
            });
            if(_isODP) {
                this.llcon.css({
                    "position": "static",
                    "top":'auto',
                    'width': 'auto'
                });
            }
        }

    };

    StickyRightColumn.prototype.getHeight = function() {
        return (this.$rightColumn) ? this.$rightColumn.outerHeight() : 0;
    };

    StickyRightColumn.prototype.getWidth = function() {
        return (this.$rightColumn) ? this.$rightColumn.outerWidth() : 0;
    };

    StickyRightColumn.prototype.getStickyPos = function() {
        return (this.$adTagHeader && this.$adTagHeader.hasClass("stickHeader") == true) ? this.$adTagHeader.outerHeight() : 0;
    };

    // create the sticky right column control
    stickyRightColumn = new StickyRightColumn();
}($));

/* end stickyRightColumn behavior */

/* Start Clear functions for 141, 420 and 520*/
function clear141() {
    //if we have an ad in the footer
    $(".additional-141").remove();

    $('.adSpcHolder').each(function(index) {
        if ($(this).attr('id') != 'plcHold-141') {
            if ($(this).find(">:first-child").attr('id').indexOf('ads-pos-141') !== -1) {
                $(this).remove();
            }
        }
    });

    $('#plcHold-141').empty();

    for (key in webmd.ads2.ads) {
        if (webmd.ads2.ads.hasOwnProperty(key)) {
            if (key.indexOf("ads-pos-141") !== -1) {
                delete webmd.ads2.ads[key];
            }
        }
    }

}

//Clear the existing 420 ad
function clear420() {
    $('.txtAd420SpcHolder').each(function(index) {
        if ($(this).attr('id') != 'plcHold-420') {
            if ($(this).find(">:first-child").attr('id').indexOf('ads-pos-420') !== -1) {
                $(this).remove();
            }
        }
    });

    $('#plcHold-420').empty();

    for (key in webmd.ads2.ads) {
        if (webmd.ads2.ads.hasOwnProperty(key)) {
            if (key.indexOf("ads-pos-420") !== -1) {
                delete webmd.ads2.ads[key];
            }
        }
    }
}

/* Clear existing 520 Ad */
function clear520() {
    $('.txtAd520SpcHolder').each(function(index) {
        if ($(this).attr('id') != 'plcHold-520') {
            if ($(this).find(">:first-child").attr('id').indexOf('ads-pos-520') !== -1) {
                $(this).remove();
            }
        }
    });

    $('#plcHold-520').empty();

    for (key in webmd.ads2.ads) {
        if (webmd.ads2.ads.hasOwnProperty(key)) {
            if (key.indexOf("ads-pos-520") !== -1) {
                delete webmd.ads2.ads[key];
            }
        }
    }
}
/* End Clear functions for 141, 420 and 520*/

/* Helper Function used in moving 141 when clashing into right rail */
function isBrkPnt2Or3() {
    if (profads.ads2.getBrkPnt() === '768-1023' || profads.ads2.getBrkPnt() === '1024-1279') {
        return true;
    } else {
        return false;
    }
}

/* Start navTracking Function  */

function navTracking(trackingObj, pageNum) {
    $(document).one("pvidReset", {
        wmdPV1: trackurl + '_' + trackingObj['CPage'],
        wmdPV2: trackingObj['CPage'],
        wmdT1: trackingObj['nxOrPrvTrk']
    }, function(event) {
        if (typeof profads !== "undefined" && profads.ads2.KillSwitch()) {
            //remove element clear for viewability fix
            if (breakpoint === 1) {} else {
                refreshMedscapeAds(trackingObj['nxOrPrvTrk'], trackingObj['CPage']);
            }
        }
        wmdTrack(event.data.wmdT1);
        wmdPageview(event.data.wmdPV1, event.data.wmdPV2);
    });
    GenPVID();
    BItrack(pageNum);
}

/* End Nav Tracking Function*/

function refreshMedscapeAds(nxOrPrvTrk, CPage) {
	if (typeof profads !== "undefined" && typeof webmd.ads2.display !== "undefined" && profads.ads2.KillSwitch()) {
		if (typeof mscpAbGrp != 'undefined' && mscpAbGrp) {
			var pbData = {wmdT1: nxOrPrvTrk};
			DesktopAdMove.adHashInit(CPage, pbData);
		} else {
			if (_isAnArticle) {
				if ((PageMetadata.reqHeaders.device === "PC") && breakpoint >= 2) {
					stickyHead.stickyRefresh();
				}
				if ((PageMetadata.reqHeaders.device === "PC") || (PageMetadata.reqHeaders.device === "IPAD" || isiPad)) {
					refreshStickyAndLoadLLAds.removeLazyLoadedAds();
				}
			}
			$(document).one("refreshMedAds", {
				wmdT1: nxOrPrvTrk
			}, function(event, pbData) {
				DesktopAdMove.adHashInit(CPage, pbData);
			});
			profads.ads2.medscapeRefresh();		
			if (_isAnArticle) {
				if ((PageMetadata.reqHeaders.device === "PC") || (PageMetadata.reqHeaders.device === "IPAD" || isiPad)) {
					refreshStickyAndLoadLLAds.initStickyAds();
				}
			}
		}
	}
}

var iADUnique = 1;
var DesktopAdMove = {
    adHashInit: function(hashtoshow, pbData) {
        if (typeof profads !== "undefined" && typeof webmd.ads2.display !== "undefined" && profads.ads2.KillSwitch()) {
            if (typeof pbData !== "undefined") {

                clear141();
                clear520();
                clear420();
                if (Number(hashtoshow) == 1) {
                    var adObjN = {};

                    if ($('#plcHold-520').length !== 0) {
                        var new520ID = "ads-pos-520_" + hashtoshow + '_' + iADUnique;
                        $('#plcHold-520').append('<div class="AdUnit inLine520" id="' + new520ID + '"></div>');
                        $('#plcHold-520').addClass('txtAd520SpcHolder');
                        delete window.ads2_ignore["520"];
                        webmd.ads2.defineAd({ id: new520ID, pos: '520', refresh: false });
                        adObjN[new520ID] = true;
                    }

                    if ($('#plcHold-141').length !== 0) {
                        var inAdPos = $("#plcHold-141").position();
                        if (profads.ads2.adCollideTest(inAdPos) && isBrkPnt2Or3()) {
                            $("#plcHold-141").remove();
                            var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                            delete window.ads2_ignore["141"];
                            webmd.ads2.setPageTarget('al', 'bl_low');
                            $("#rel-links").prepend('<div class="adSpcHolder additional-141"><div id="' + new141ID + '" class="AdUnit"></div></div>');

                            if (!lazyLoadBlbVP.should141LazyLoad()) {
                                webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                                adObjN[new141ID] = true;
                            }
                        } else {
                            var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                            webmd.ads2.setPageTarget('al', 'bl_high');
                            $('#plcHold-141').append('<div id="' + new141ID + '" class="inLine141 AdUnit"></div>');
                            $('#plcHold-141').addClass('adSpcHolder');
                            delete window.ads2_ignore["141"];

                            if (!lazyLoadBlbVP.should141LazyLoad()) {
                                webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                                adObjN[new141ID] = true;
                            }
                        }

                    }

                    if ($('#plcHold-420').length !== 0) {
                        var new420ID = "ads-pos-420_" + hashtoshow + '_' + iADUnique;
                        $('#plcHold-420').append('<div class="AdUnit inLine420" id="' + new420ID + '"></div>');
                        $('#plcHold-420').addClass('txtAd420SpcHolder');
                        delete window.ads2_ignore["420"];
                        webmd.ads2.defineAd({ id: new420ID, pos: '420', refresh: false });
                        adObjN[new420ID] = true;
                    }

                    if ($('div[id^="ads-pos-141"]').length === 0) {
                        var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                        delete window.ads2_ignore["141"];
                        webmd.ads2.setPageTarget('al', 'bl_low');
                        $("#rel-links").prepend('<div class="adSpcHolder additional-141"><div id="' + new141ID + '" class="AdUnit"></div></div>');

                        if (!lazyLoadBlbVP.should141LazyLoad()) {
                            webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                            adObjN[new141ID] = true;
                        }

                    }
					if (typeof mscpAbGrp == 'undefined' || !mscpAbGrp) {
						adObjN['ads-pos-101'] = true;
						adObjN['ads-pos-122'] = true;
						adObjN['ads-pos-910'] = true;
					}
                    webmd.ads2.setPageTarget('ll', '0');
                    webmd.ads2.setPageTarget('ep', '0');

                    webmd.ads2.refresh({
                        id: adObjN
                    });

                } else {
                    var adObjN = {};

                    // unique cases when the 420 goes into the second page
                    if ($('#pageN_' + Number(hashtoshow) + " #plcHold-420").length > 0) {

                        clear420();
                        var new420ID = "ads-pos-420_" + hashtoshow + '_' + iADUnique;
                        $('#plcHold-420').append('<div class="AdUnit inLine420" id="' + new420ID + '"></div>');
                        $('#plcHold-420').addClass('txtAd420SpcHolder');
                        delete window.ads2_ignore["420"];
                        webmd.ads2.defineAd({ id: new420ID, pos: '420', refresh: false });
                        adObjN[new420ID] = true;


                        var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                        var inConSecObj141 = $("#pageN_" + hashtoshow + " div.inContentAd:eq( 2 )");
                        if (inConSecObj141.length !== 0) {
                            delete window.ads2_ignore["141"];
                            webmd.ads2.setPageTarget('al', 'bl_high');
                            inConSecObj141.append('<div class="adSpcHolder"><div id="' + new141ID + '" class="inLine141 AdUnit"></div></div>');
                            if (!lazyLoadBlbVP.should141LazyLoad()) {
                                webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                                adObjN[new141ID] = true;
                            }
                        }

                        if (inConSecObj141.length !== 0) {
                            var new520ID = "ads-pos-520_" + hashtoshow + '_' + iADUnique;
                            var inConSecObj520 = inConSecObj141.nextAll(".inContentAd").eq(2);
                            if (inConSecObj520.length !== 0) {
                                delete window.ads2_ignore["520"];
                                inConSecObj520.append('<div class="txtAd520SpcHolder"> <div class="AdUnit inLine520" id="' + new520ID + '"></div></div>');
                                webmd.ads2.defineAd({ id: new520ID, pos: '520', refresh: false });
                                adObjN[new520ID] = true;
                            }
                        }

                    } else {
                        var new520ID = "ads-pos-520_" + hashtoshow + '_' + iADUnique;
                        var inConSecObj520 = $("#pageN_" + hashtoshow + " div.inContentAd:eq( 2 )");
                        if (inConSecObj520.length !== 0) {
                            inConSecObj520.append('<div class="txtAd520SpcHolder"> <div class="AdUnit inLine520" id="' + new520ID + '"></div></div>');
                            delete window.ads2_ignore["520"];
                            webmd.ads2.defineAd({ id: new520ID, pos: '520', refresh: false });
                            adObjN[new520ID] = true;
                        }

                        var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                        var inConSecObj141 = $("#pageN_" + hashtoshow + " div.inContentAd:eq( 5 )");
                        if (inConSecObj141.length !== 0) {

                            var inAdPos = inConSecObj141.position();
                            if (profads.ads2.adCollideTest(inAdPos) && isBrkPnt2Or3()) {

                                var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                                delete window.ads2_ignore["141"];
                                webmd.ads2.setPageTarget('al', 'bl_low');
                                $("#rel-links").prepend('<div class="adSpcHolder additional-141"><div id="' + new141ID + '" class="inLine141 AdUnit"></div></div>');

                                if (!lazyLoadBlbVP.should141LazyLoad()) {
                                    webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                                    adObjN[new141ID] = true;
                                }
                            } else {
                                delete window.ads2_ignore["141"];
                                webmd.ads2.setPageTarget('al', 'bl_high');
                                inConSecObj141.append('<div class="adSpcHolder"><div id="' + new141ID + '" class="inLine141 AdUnit"></div></div>');
                                if (!lazyLoadBlbVP.should141LazyLoad()) {
                                    webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                                    adObjN[new141ID] = true;
                                }
                            }
                        }

                        if (inConSecObj141.length !== 0) {
                            var new420ID = "ads-pos-420_" + hashtoshow + '_' + iADUnique;
                            var inConSecObj420 = inConSecObj141.nextAll(".inContentAd").eq(2);
                            if (inConSecObj420.length !== 0) {
                                delete window.ads2_ignore["420"];
                                inConSecObj420.append('<div class="txtAd420SpcHolder"> <div class="AdUnit inLine420" id="' + new420ID + '"></div></div>');
                                webmd.ads2.defineAd({ id: new420ID, pos: '420', refresh: false });
                                adObjN[new420ID] = true;
                            }
                        }
                    }

                    if ($('div[id^="ads-pos-141"]').length === 0) {
                        var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                        delete window.ads2_ignore["141"];
                        webmd.ads2.setPageTarget('al', 'bl_low');
                        $("#rel-links").prepend('<div class="adSpcHolder additional-141"><div id="' + new141ID + '" class="inLine141 AdUnit"></div></div>');

                        if (!lazyLoadBlbVP.should141LazyLoad()) {
                            webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                            adObjN[new141ID] = true;
                        }

                    }
					if (typeof mscpAbGrp == 'undefined' || !mscpAbGrp) {
						adObjN['ads-pos-101'] = true;
						adObjN['ads-pos-122'] = true;
						adObjN['ads-pos-910'] = true;
					}
                    webmd.ads2.setPageTarget('ll', '0');
                    webmd.ads2.setPageTarget('ep', '0');

                    webmd.ads2.refresh({
                        id: adObjN
                    });
                }

            } else {

                if (Number(hashtoshow) == 1) {
                    lazyLoadBlbVP.should141LazyLoad();

                    if ($('#plcHold-141').length !== 0) {
                        var inAdPos = $("#plcHold-141").position();
                        if (profads.ads2.adCollideTest(inAdPos) && isBrkPnt2Or3()) {

                            $("#plcHold-141").remove();
                            var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                            webmd.ads2.setPageTarget('al', 'bl_low');
                            $("#rel-links").prepend('<div class="adSpcHolder additional-141"><div id="' + new141ID + '" class="AdUnit"></div></div>');
                            webmd.ads2.defineAd({ id: new141ID, pos: '141' });

                        } else {
                            webmd.ads2.setPageTarget('al', 'bl_high');
                        }
                    }

                    if ($('div[id^="ads-pos-141"]').length === 0) {
                        webmd.ads2.setPageTarget('al', 'bl_high');
                        $("#rel-links").prepend('<div class="adSpcHolder additional-141"><div class= "AdUnit" id="ads-pos-141"></div></div>');
                        webmd.ads2.defineAd({ id: 'ads-pos-141', pos: '141' });
                    }

                    webmd.ads2.refresh();
                } else {
                    var adObjN = {};
                    // unique cases when the 420 goes into the second page
                    if ($('#pageN_' + Number(hashtoshow) + " #plcHold-420").length > 0) {

                        clear420();
                        var new420ID = "ads-pos-420_" + hashtoshow + '_' + iADUnique;
                        $('#plcHold-420').append('<div class="AdUnit inLine420" id="' + new420ID + '"></div>');
                        $('#plcHold-420').addClass('txtAd420SpcHolder');
                        delete window.ads2_ignore["420"];
                        webmd.ads2.defineAd({ id: new420ID, pos: '420', refresh: false });
                        adObjN[new420ID] = true;


                        var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                        var inConSecObj141 = $("#pageN_" + hashtoshow + " div.inContentAd:eq( 2 )");
                        if (inConSecObj141.length !== 0) {
                            delete window.ads2_ignore["141"];
                            webmd.ads2.setPageTarget('al', 'bl_high');
                            inConSecObj141.append('<div class="adSpcHolder"><div id="' + new141ID + '" class="inLine141 AdUnit"></div></div>');
                            if (!lazyLoadBlbVP.should141LazyLoad()) {
                                webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                                adObjN[new141ID] = true;
                            }
                        }

                        if (inConSecObj141.length !== 0) {
                            var new520ID = "ads-pos-520_" + hashtoshow + '_' + iADUnique;
                            var inConSecObj520 = inConSecObj141.nextAll(".inContentAd").eq(2);
                            if (inConSecObj520.length !== 0) {
                                delete window.ads2_ignore["520"];
                                inConSecObj520.append('<div class="txtAd520SpcHolder"> <div class="AdUnit inLine520" id="' + new520ID + '"></div></div>');
                                webmd.ads2.defineAd({ id: new520ID, pos: '520', refresh: false });
                                adObjN[new520ID] = true;
                            }
                        }

                    } else {
                        var new520ID = "ads-pos-520_" + hashtoshow + '_' + iADUnique;
                        var inConSecObj520 = $("#pageN_" + hashtoshow + " div.inContentAd:eq( 2 )");
                        if (inConSecObj520.length !== 0) {
                            inConSecObj520.append('<div class="txtAd520SpcHolder"> <div class="AdUnit inLine520" id="' + new520ID + '"></div></div>');
                            delete window.ads2_ignore["520"];
                            webmd.ads2.defineAd({ id: new520ID, pos: '520', refresh: false });
                            adObjN[new520ID] = true;
                        }

                        var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                        var inConSecObj141 = $("#pageN_" + hashtoshow + " div.inContentAd:eq( 5 )");
                        if (inConSecObj141.length !== 0) {
                            var inAdPos = inConSecObj141.position();

                            if (profads.ads2.adCollideTest(inAdPos) && isBrkPnt2Or3()) {
                                var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                                delete window.ads2_ignore["141"];
                                webmd.ads2.setPageTarget('al', 'bl_low');
                                $("#rel-links").prepend('<div class="adSpcHolder additional-141"><div id="' + new141ID + '" class="inLine141 AdUnit"></div></div>');
                                adObjN[new141ID] = true;

                                if (!lazyLoadBlbVP.should141LazyLoad()) {
                                    webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                                }
                            } else {
                                delete window.ads2_ignore["141"];
                                webmd.ads2.setPageTarget('al', 'bl_high');
                                inConSecObj141.append('<div class="adSpcHolder"><div id="' + new141ID + '" class="inLine141 AdUnit"></div></div>');
                                if (!lazyLoadBlbVP.should141LazyLoad()) {
                                    webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                                    adObjN[new141ID] = true;
                                }
                            }
                        }

                        if (inConSecObj141.length !== 0) {
                            var new420ID = "ads-pos-420_" + hashtoshow + '_' + iADUnique;
                            var inConSecObj420 = inConSecObj141.nextAll(".inContentAd").eq(2);
                            if (inConSecObj420.length !== 0) {
                                delete window.ads2_ignore["420"];
                                inConSecObj420.append('<div class="txtAd420SpcHolder"> <div class="AdUnit inLine420" id="' + new420ID + '"></div></div>');
                                webmd.ads2.defineAd({ id: new420ID, pos: '420', refresh: false });
                                adObjN[new420ID] = true;
                            }
                        }
                    }

                    if ($('div[id^="ads-pos-141"]').length === 0) {
                        var new141ID = "ads-pos-141_" + hashtoshow + '_' + iADUnique;
                        delete window.ads2_ignore["141"];
                        webmd.ads2.setPageTarget('al', 'bl_low');
                        $("#rel-links").prepend('<div class="adSpcHolder additional-141"><div id="' + new141ID + '" class="inLine141 AdUnit"></div></div>');

                        if (!lazyLoadBlbVP.should141LazyLoad()) {
                            webmd.ads2.defineAd({ id: new141ID, pos: '141', refresh: false });
                            adObjN[new141ID] = true;
                        }

                    }
					if (typeof mscpAbGrp == 'undefined' || !mscpAbGrp) {
						adObjN['ads-pos-101'] = true;
						adObjN['ads-pos-122'] = true;
						adObjN['ads-pos-910'] = true;
					}
                    webmd.ads2.refresh({
                        id: adObjN
                    });
                }
            }
            iADUnique++;
        }
        
    }
};

/* (START) Lazyloading Blb for Pfizer brands only on virtual pages */
var lazyLoadBlbVP;
lazyLoadBlbVP = window.lazyLoadBlbVP || {};
lazyLoadBlbVP = {
    lazyloaded: false,
    should141LazyLoad: function() {
        lazyLoadBlbVP.lazyloaded = false;
        // if is Pfizer brands
        if (PageMetadata.lazyLoad != null) {
            if (PageMetadata.lazyLoad.blb != null) {
                if (PageMetadata.lazyLoad.blb && bNews) {

                    lazyLoadBlbVP.lazyloaded = true;

                    // wait for virtual page to calculate it's height;
                    setTimeout(function() {
                        window.ads2_ignore["141"] = "true";
                        lazyLoadBlb.init();
                    }, 2000);
                }

            }
        }

        if (!lazyLoadBlbVP.lazyloaded) {
            return false;
        } else {
            return true;
        }

    }

};
/* (END) LazyLoading Blb for virtual pages */

/*
 // News Lazy loaded Ads
 var _newsLazyLoadAds;
 _newsLazyLoadAds = window._newsLazyLoadAds || {};
 var _addId = 0; // counter for ads to make every ad unique

 _newsLazyLoadAds = {
 adsAssumedHeight: 1020,
 marginUnderRightCol: 500,
 howLongRightRailStick : 155, // Accounting for how long right rail sticks approximation
 hasFullReloadRun: false,
 numberOfLoadedAds:0,
 init: function (virtualPage) {

 var self = this;
 // Do a check to make sure nobody tries to run init twice per page load unless is a hashtag/virtual page reload
 if (self.init.flag) {
 if (!(virtualPage === "virtual_page")) {
 return;
 }
 }

 if (virtualPage === "virtual_page" && !_newsLazyLoadAds.hasFullReloadRun) {

 return;
 }

 _newsLazyLoadAds.numberOfLoadedAds = 1;
 _newsLazyLoadAds.hasFullReloadRun = true;
 self.init.flag = true;

 _newsLazyLoadAds._newsLazyLoadAdsScrollHandler();

 },
 _newsLazyLoadAdsScrollHandler: function () {
 _newsLazyLoadAds.removeLazyLoadedAds(); // remove existing ads, if any
 $('#adcontainer_column-right').children().last().css("margin-bottom",0); // reset margin
 var adArray = _newsLazyLoadAds.getLazyLoadAdArrayPositions();
 if (adArray.length === 0) {

 $(window).off("scroll.addLazyLoadedAds");
 return; //quit page is too small for ad
 } else {
 $(window).off("scroll.addLazyLoadedAds").on("scroll.addLazyLoadedAds", function () {
 _newsLazyLoadAds.addLazyLoadedAds(adArray);
 });
 }

 },
 removeLazyLoadedAds: function () {
 // they have a special class
 $(".lazyLoaded-dd-ads").remove();


 },
 getLazyLoadAdArrayPositions: function () {

 var adArray = [];
 var rightColHeight = $('#adcontainer_column-right').outerHeight() + _newsLazyLoadAds.marginUnderRightCol;


 var leftContentHeight = $("#article-content").outerHeight() - _newsLazyLoadAds.howLongRightRailStick;

 var remainingSpaceForAds = leftContentHeight - rightColHeight;
 var numberOfPossibleAds = Math.floor(remainingSpaceForAds / _newsLazyLoadAds.adsAssumedHeight);

 if (numberOfPossibleAds >= 1) {
 $('#adcontainer_column-right').children().last().css("margin-bottom", _newsLazyLoadAds.marginUnderRightCol);
 var firstAdPosition = Math.floor($("#adcontainer_column-right").offset().top + rightColHeight);
 _addId++;

 adArray.push({
 hasAdBeenLoaded: false,
 id: 0,
 positionOfAd: firstAdPosition
 });

 for (var i = 1; i < numberOfPossibleAds; i++) {
 adArray.push({
 hasAdBeenLoaded: false,
 id: i,
 positionOfAd: adArray[i - 1].positionOfAd + _newsLazyLoadAds.adsAssumedHeight
 });
 }

 return adArray;

 } else {
 return adArray;
 }
 },


 addLazyLoadedAds: function (adArray) {


 for (var i = 0; i < adArray.length; i++) {

 if (adArray[i].positionOfAd <= ($(window).scrollTop() + 250) && !(adArray[i].hasBeenLoaded)) {

 adArray[i].hasBeenLoaded = true;

 var ad_615_id = "ad_615_" + adArray[i].id + "_" + _addId;
 var ad_319_id = "ad_319_" + adArray[i].id + "_" + _addId;

 if (_newsLazyLoadAds.is141AdInView(adArray[i].positionOfAd)) {
 $("#adcontainer_column-right").append('<div class="lazyLoaded-dd-ads skip-141"><div style="margin-bottom:250px; min-height:260px" id="' + ad_615_id + '"></div>' + '<div style="margin-bottom:250px; min-height:260px" id="' + ad_319_id + '"></div></div>');

 } else {

 $("#adcontainer_column-right").append('<div class="lazyLoaded-dd-ads"><div class="" style="margin-bottom:250px" id="' + ad_615_id + '"></div>' + '<div class="" style="margin-bottom:500px" id="' + ad_319_id + '"></div></div>');

 webmd.ads2.defineAd({id: ad_615_id, pos: '615'});
 webmd.ads2.defineAd({id: ad_319_id, pos: '319'});


 var adObj = {};
 adObj[ad_615_id] = true;
 adObj[ad_319_id] = true;
 webmd.ads2.setPageTarget('ll', 'rrll_' + (_newsLazyLoadAds.numberOfLoadedAds++));
 webmd.ads2.setPageTarget('al', '0');
 webmd.ads2.refresh({
 id: adObj
 });

 }

 }
 // if we have loaded the last one then all has been loaded so kill off event
 else if (adArray[adArray.length - 1].hasBeenLoaded) {
 $(window).off("scroll.addLazyLoadedAds");
 }
 }
 },

 // make sure it is not in view and not crossing each other
 is141AdInView: function (nextADOffsetTop) {

 var $ad141 = $('div[id^="ads-pos-141"]:visible').first(); // only one visible 141 on page
 if ($ad141.length === 0 || !$ad141.is(':visible')) {
 return false;
 }


 // to make sure 141 is not inview
 var $window = $(window);
 var docViewTop = $window.scrollTop();
 var docViewBottom = docViewTop + $window.height();
 var elemTop = $ad141.offset().top;
 var elemBottom = elemTop + $ad141.height();

 if (((elemBottom <= docViewBottom) && (elemTop >= docViewTop))) {

 return true; // yes 141 is inview do not load real ads
 }


 // to make sure 141 is not intersecting lazy loaded ads
 var ad141Bottom = $ad141.offset().top + $ad141.height();
 var nextAdBottom = nextADOffsetTop + _newsLazyLoadAds.adsAssumedHeight;
 if (ad141Bottom > nextADOffsetTop && ad141Bottom < nextAdBottom) {

 return true; // yes 141 is intersecting lazy loaded ads do not load real ads
 }
 else{

 return false;
 }

 }

 };
 */

/* begin rightColumn Lazy Load namespace */
var rrLazyLoadAds = window.rrLazyLoadAds || {};
rrLazyLoadAds = {
    adId: 0, // used to generate the id for the adslot
    adsContainerHeight: 1270, // adcontainer height
    scrolldelay: 250, // pauses scrolling so ads dont trigger when users scroll too quickly
    $llcontainer: null, // caches the container holding the lazyloaded ad containers
    loadwaittime: 2000, // time to wait before loading the ads after dfpRenderComp event
    seladheader: "", // ad tag header container element selector
    seladright: "", // ad tag right container element selector
    selleftcol: "", // left column container element selector

    init: function(seladheader, seladright, selleftcol) {
        var self = this;
        if (self.init.flag)
            return;
        this.seladheader = seladheader;
        this.seladright = seladright;
        this.selleftcol = selleftcol;

        $(document).ready(function() {
            // add this container to account for sticky right column space
            $(self.seladright).wrap("<div id=\"sticky_rightcol\"></div>");
            $("#sticky_rightcol").after("<div id=\"ll-container\"></div>");
        });


        $(document).one("dfpRenderComp", function() {
            // after initial ads are loaded wait before setting up lazyloaded ads
            var timeoutid = setTimeout(function() {
                $(window).resize(function() {
                    self.setupRightColumnSpace();
                    self.markVisibleContainers();
                });
                $(window).resize();
                self.refresh();
                clearTimeout(timeoutid);
            }, self.loadwaittime);
        });

        self.init.flag = true;
    },

    setupRightColumnSpace: function() {
        // determine how much space the stickyRR take including the space for sticky scrolling
        var stickyrrheight = $(this.seladright).outerHeight(true);
        var stickyrrsticklength = stickyRightColumn.howLongRightRailStick;
        var stickyheadheight = $(this.seladheader).outerHeight();
        var stickyrrspace = stickyrrheight + stickyrrsticklength + stickyheadheight + 40;
        if(_isODP === false) {
            $("#sticky_rightcol").css("height", stickyrrspace + "px");
        }
        var llheight = $(this.selleftcol).height() - stickyrrspace;
        $('#ll-container').css("height", llheight + "px");
        setTimeout(function(){
			$("#ll-container").css('height','auto');
		},100);
    },

    buildLLAdsContainers: function() {
        // determine the number of containers to build based on the height of the lazyload container
        var $llcontainer = $("#ll-container");
        $(".ll-ads-container").remove();
        var numofcontainers = Math.floor($llcontainer.outerHeight() / this.adsContainerHeight);
        for (var i = 0; i < numofcontainers; i++)
            $llcontainer.append(this.buildLLAdsContainer(i));
    },

    buildLLAdsContainer: function(i) {
        var id122 = "ad_122_" + i + "_" + this.adId;
        var id910 = "ad_910_" + i + "_" + this.adId;
        var str = "<div id=\"ll-ads-container-" + i + "\"class=\"ll-ads-container\">";
        str += "<div id=\"" + id122 + "\" data-pos=\"122\" class=\"ll-ad-slot ll-ad-slot-122\"></div>";
        str += "<div id=\"" + id910 + "\" data-pos=\"910\" class=\"ll-ad-slot ll-ad-slot-910\"></div>";
        str += "</div>";
        this.adId++;
        return str;
    },

    isInViewport: function($el, trigger) {
        if (!$el || $el.length === 0)
            return false;
        var eltop = $el.offset().top;
        var elbottom = eltop + $el.height();
        var vptop = $(window).scrollTop();
        var vpbottom = vptop + $(window).height();
        return (eltop <= (vpbottom + trigger) && elbottom >= (vptop - trigger))
    },

    isOverlapping: function($el1, $el2) {
        if (!$el1 || $el1.length === 0 || !$el1.is(':visible') ||
            !$el2 || $el2.length === 0 || !$el2.is(':visible'))
            return false;
        var el1top = $el1.offset().top;
        var el1bottom = el1top + $el1.height();
        var el2top = $el2.offset().top;
        var el2bottom = el2top + $el2.height();
        return (el1top <= el2bottom && el1bottom >= el2top);
    },

    doLazyLoadOnScroll: function() {
        var self = this;
        // lazyload only the visible containers
        $(".ll-ads-container.is-visible").each(function() {
            var $container = $(this);
            var bisll = $container.hasClass("is-ll");
            if (!bisll && self.isInViewport($container, 250)) {
                var adObj = {};
                var $adslots = $container.find(".ll-ad-slot");
                var sizes_122 = webmd.ads2.sizes['122'];
                var sizes_910 = webmd.ads2.sizes['910']; // save the sizes
                webmd.ads2.sizes['122'] = [
                    [300, 250],
                    [300, 251],
                    'fluid'
                ];
                webmd.ads2.sizes['910'] = [
                    [300, 250],
                    [300, 251],
                    'fluid'
                ];
                // don't load if container has no adslots
                if ($adslots.length == 0)
                    return;

                // lazyload the adslots defined in the container
                $adslots.each(function() {
                    var $adslot = $(this);
                    var id = $adslot.attr("id");
                    var pos = $adslot.attr("data-pos");
                    $adslot.addClass("AdUnit");
                    if(PageMetadata.userSegVars.dt != undefined){
                        profads.ads2.spbr["122"] = "";
                    }
                    webmd.ads2.defineAd({ id: id, pos: pos, sizes: [300, 250], refresh: false });
                    adObj[id] = true;
                });
                if (typeof profads.ads2.pageAdVars !== "undefined") {
                    var lif = profads.ads2.pageAdVars['lif'];
                    if (lif !== undefined)
                        webmd.ads2.setPageTarget('lif', lif);
                }
                webmd.ads2.setPageTarget('ll', '1');

                webmd.ads2.refresh({ id: adObj });
                webmd.ads2.sizes['122'] = sizes_122;
                webmd.ads2.sizes['910'] = sizes_910; // restore the sizes
                $container.addClass("is-ll"); // indicate the container was lazyloaded
            }
        });
    },

    refresh: function() {
        var self = this;
        $('#ll-container').css("height", 0 + "px");
        this.setupRightColumnSpace();
        this.buildLLAdsContainers();
        this.markVisibleContainers();
        $(window).off("scroll.doLazyLoadOnScroll").on("scroll.doLazyLoadOnScroll", function() {
            clearTimeout(self.rrlazyloadevent);
            self.rrlazyloadevent = setTimeout(function() {
                self.doLazyLoadOnScroll();
            }, self.scrolldelay);
        });
    },

    markVisibleContainers: function() {
        var self = this;
        var $ad141 = $('div[id^="ads-pos-141"]:visible').first();
        var $rlinks = $("#rel-links");
        if(_isODP){
            ads2_ignore["910"] = false;
            window.ads2_ignoreIds['ads-pos-910'] = true;
             $rlinks =  $("#adtagfooter");
        }
        // tag any overlapping ads containers
        $(".ll-ads-container").each(function() {
            var $lladscontainer = $(this);
            if(self.isOverlapping($lladscontainer, $ad141) || self.isOverlapping($lladscontainer, $rlinks)){
                $lladscontainer.removeClass("is-visible");
                if(_isODP){
                    $lladscontainer.addClass("is-visible");
                }
            }  
            else{
                $lladscontainer.addClass("is-visible");
            } 
        });
    }
};

var isiPad = navigator.userAgent.match(/iPad/i) != null;
var leftContentHeight = $("#column-left").height();
if ((locale == "us" && !isiPad) && (detectDevice() !== 'mobile') && leftContentHeight>1400)
    rrLazyLoadAds.init("#adtagheader", "#adcontainer_column-right", "#column-left");
/* end rightColumn Lazy Load namespace */

// Virtual Page logics
var refreshStickyAndLoadLLAds;
refreshStickyAndLoadLLAds = window.refreshStickyAndLoadLLAds || {};

refreshStickyAndLoadLLAds = {
    initStickyAds: function() {
        setTimeout(function() {
            //_newsLazyLoadAds.init("virtual_page");
            rrLazyLoadAds.refresh();
        }, 2000);
    },
    //remove lazy loaded ads on virtual pages
    removeLazyLoadedAds: function() {
        // _newsLazyLoadAds.removeLazyLoadedAds();
    }

};

function detectDevice() {
    var device;
    if (window.innerWidth <= 768) //use window.innerWidth instead of $(window).width() to count the left scrollbar and to match css mediaqueries
        device = "mobile";
    else if (window.innerWidth > 768 && window.innerWidth <= 980)
        device = "tablet";
    else
        device = "desktop";

    return device;
}

function adLazyLoadHandler() {
	clearTimeout(adLazyLoadEvent);
	adLazyLoadEvent = setTimeout("scrollEvents.adLazyLoad()", 250);
}

function trackPingHandler() {
	clearTimeout(trackScroll);
	trackScroll = setTimeout("scrollEvents.trackPing()", 1000);
}

var trackScroll, adLazyLoadEvent, trackurl, hashNo = 1, lazyAdsInc = 0;

var scrollEvents = {
    classInConAd: [],
    lastPos: $(window).scrollTop(),
    sclPos: $(window).scrollTop(),
	
    init: function() {
		
		var self = this;
		
		// reinitialize values when calling init again
		hashNo = 1;
		this.lastPos = $(window).scrollTop();
		this.sclPos = $(window).scrollTop();
		self.classInConAd = [];
		
		var artSelector = '.article-wrapper:last ';
		if (document.querySelector('.inf-art-wrap') != null) {
			artSelector = '.inf-art-wrap[data-contenturl="' + currSlctCont + '"]';
			$(artSelector + " [id*='ads-pos-1122_'], " + artSelector + " .inContentAd").each(function() {
				$(this).removeAttr('style');
				$(this).removeAttr('id');
				$(this).removeAttr('rel');
				$(this)[0].className = 'inContentAd';
			});
		}
		
		$(artSelector + " .inContentAd").filter( function(idx) { return (idx%3 == 0 )} ).each(function() {
			self.classInConAd.push(this);
		});
		
        scrollEvents.addId();
		
		// unbind handlers when calling init again
		$(window).off("scroll.addNewsLazyLoadAds", adLazyLoadHandler);
		$(window).off("scroll", trackPingHandler);
		
        $(window).on("scroll.addNewsLazyLoadAds", adLazyLoadHandler).on("scroll", trackPingHandler);
    },
    addId: function() {
        $(this.classInConAd).each(function() {
            $(this)
                .attr('id', "ads-pos-1122_" + lazyAdsInc)
                .attr('rel', lazyAdsInc);
			lazyAdsInc++;
        });
    },
    trackPing: function() {
        var factor = 1.5;
        var currentPos = this.sclPos + $(window).height() * factor;
        if (currentPos < $(window).scrollTop()) {
            wmdTrack('ar-scrdn_' + hashNo);
            wmdPageview(trackurl + '-0-' + hashNo, hashNo);
            BItrack('0_' + hashNo);
            hashNo = hashNo + 1;
        } else {
            if (this.sclPos - $(window).height() * factor > $(window).scrollTop()) {
                wmdTrack('ar-scrup' + '_' + hashNo);
                wmdPageview(trackurl + '-0-' + hashNo, hashNo);
                BItrack('0_' + hashNo);
                hashNo = hashNo + 1;
            }
        }
        if (this.sclPos + $(window).height() * factor < $(window).scrollTop() || this.sclPos - $(window).height() * factor > $(window).scrollTop()) {
            this.sclPos = $(window).scrollTop();
        }

        return this;
    },
    adLazyLoad: function() {
        if(window.breakpoint !== 1) return;
        $(this.classInConAd).each(function(i, el) {
            if (scrollEvents.scrollIntoView(el) && !$(this).eq(i).hasClass('AdUnit')) {
                $(this).addClass("AdUnit");
                webmd.ads2.setPageTarget('ep', '0');
                webmd.ads2.setPageTarget('ll', '1');
                webmd.ads2.setPageTarget('al', $(this).attr('rel'));
                profads.ads2.proclivityRefresh('ads-pos-1122', $(this).attr('id'));
                // moving ad define into success for proclivityRefresh ajax call
            }
        });
        // scrollEvents.removeLazyLoadEvent();
    },
    removeLazyLoadEvent: function() {

        var hasFinishLoading = true;
        $(this.classInConAd).each(function(i) {
            if (!$(this).hasClass('AdUnit')) {
                hasFinishLoading = false;
                return;
            }
        });

        if (hasFinishLoading) {
            $(window).off("scroll.addNewsLazyLoadAds");
        }
    },
    scrollIntoView: function(elem) {
        var $elem = $(elem);
        if (!($elem && $elem.length > 0)) return false;
        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        return ($elem.is(':visible') && (elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
};

// handle discrepancy in Aspen/Vue article Ads HTML on legacy stack
function a2aVueAdsAppend() {
	const currArt = document.querySelector('.inf-art-wrap[data-contenturl="' + currSlctCont + '"]');
	if (currArt.querySelector('.article__main-content') != null && currArt.querySelector('[id*=ads-pos-1122]') == null) {
		const tagParent = currArt.querySelector('.article__main-content > div:not(.pwHidden) > div:first-child');
		const contTags = tagParent.querySelectorAll(':scope p, :scope h2, :scope h3, :scope h4');
		if (contTags.length >= 2) {
			const adEl = '<div id="ads-pos-1122-' + currSlctCont.match(/[^/-]+$/)[0] + '" class="AdUnit"></div>';
			contTags[1].insertAdjacentHTML('afterend', adEl);
		}
		if (contTags.length >= 5) {
			const adEl = '<div class="txtAd1520SpcHolder" id="plcHold-1520"><div id="ads-pos-1520-' + currSlctCont.match(/[^/-]+$/)[0] + '" class="AdUnit"></div></div>';
			contTags[4].insertAdjacentHTML('afterend', adEl);
		}
		if (contTags.length >= 13) {
			for (let i=12; i < contTags.length; i++) {
				const adEl = '<div class="inContentAd"></div>';
				contTags[i].insertAdjacentHTML('afterend', adEl);
			}
		}
	}
}
document.addEventListener('beforeSwitchContent', a2aVueAdsAppend);

// Desktop Infinite-scroll AB Test
function mscpAbTrueInit() {	
	var abScrlPos = $(window).scrollTop();
	var abScrlTimeOut;
	function abScrlHandle() {
		var scrlDir = 'down';
		var currPgNum = Number(Cpage.split('_')[1]);
		if ($(window).scrollTop() < abScrlPos) {
			scrlDir = 'up';
		}	
		abScrlPos = $(window).scrollTop();
		if (scrlDir == 'down') {
			for (var x=currPgNum+1; x <= Tpages; x++) {
				if ($('#pageN_' + x)[0].getBoundingClientRect().top < window.innerHeight*.75) { 
					Cpage = 'vp_' + x;
				}
			}		
			if (currPgNum != Number(Cpage.split('_')[1])) {
				currPgNum = Number(Cpage.split('_')[1]);
				window.location.hash = Cpage;
				var trackingObj = {};
				trackingObj['CPage'] = String(currPgNum);
				trackingObj['nxOrPrvTrk'] = 'ar-nav_nx' + currPgNum;
				navTracking(trackingObj, currPgNum);
			}
		} else {
			for (var x=currPgNum-1; x > 0; x--) {
				if ($('#pageN_' + x)[0].getBoundingClientRect().y + $('#pageN_' + x)[0].getBoundingClientRect().height > 0 && $('#pageN_' + currPgNum)[0].getBoundingClientRect().top > window.innerHeight) {
					Cpage = 'vp_' + x;
				}
			}		
			if (currPgNum != Number(Cpage.split('_')[1])) {
				currPgNum = Number(Cpage.split('_')[1]);
				window.location.hash = Cpage;
				var trackingObj = {};
				trackingObj['CPage'] = String(currPgNum);
				trackingObj['nxOrPrvTrk'] = 'ar-nav_pv' + currPgNum;
				navTracking(trackingObj, currPgNum);
			}
		}
		
	}
	$(window).on('scroll', function() {
		clearTimeout(abScrlTimeOut);
		abScrlTimeOut = setTimeout(abScrlHandle, 1000);
	})
}
/* if (typeof mscpAbGrp != 'undefined' && mscpAbGrp) {
	mscpAbTrueInit();
}
if (typeof mscpAbGrp != 'undefined') {
	$(document).ready(function() {
		if (typeof webmd != 'undefined' && typeof webmd.ads2 != 'undefined' && typeof webmd.ads2.setPageTarget != 'undefined') {
			webmd.ads2.setPageTarget('tex', 'mscpinfscrl_' + mscpAbGrp);			
		}
	});
} */
// End Desktop Infinite-scroll AB Test

//lazyLoad1420 code
if(detectDevice() == "mobile" && window.textDriverOptimized == true){
    var scrollTime1420;
        var scroll1420Events = {
                init: function (){	
                 $(window).on("scroll.lazyLoad1420", function () {
                    if($('#ads-pos-1420').length > 0){
                            clearTimeout(scrollTime1420);
                         scrollTime1420 = setTimeout("scroll1420Events.lazyLoad1420()", 250);
                    }
                });
            },
            lazyLoad1420: function () {
               if (scrollEvents.scrollIntoView('#plcHold-1420') == true) {

                    if(window.textDriverOptimized ==true && typeof scroll1420 == "undefined"){
                        $('#ads-pos-1420').addClass("AdUnit").show();
                        setTimeout(function(){
                            window.ads2_ignore["1420"] = false;
                            scroll1420 = true;
                            webmd.ads2.setPageTarget('ll', '1');
                            webmd.ads2.defineAd({id: 'ads-pos-1420', pos: 1420});
                            webmd.ads2.refresh({pos: 1420});

                        },500);
                        $(window).off("scroll.lazyLoad1420");
                    }
                }
           }
        }
    }
    
//lazyLoad1420 end

/** StickyHeader, Sticky Right and Lazyload initialiazed **/
$(document).ready(function() {
    window.addEventListener('collapse', function (e) {
        const adPosDiv = document.getElementById(e.detail.iframe).parentNode.parentNode;
        if (adPosDiv.id.indexOf('101') !== -1) {
             if (adPosDiv.style.display === 'none' || $(adPosDiv).hasClass('blank-ad')) {
                 if(typeof stickyHead === "object"){
                     stickyHead.stickyKillSwitch();
                 }
                 $('#adtagheader').css('display','none');
             }
         }
    }, false);
    if (window._isAnArticle || window._isRecap) {
        if (PageMetadata.reqHeaders.device === "PC" && breakpoint >= 2) {
            webmd.ads2.setPageTarget('ll', '0');
            stickyHead.init();
            // Disable sticky ad for indiscussion
            if ($('.in-discussion').length == 0) {
                stickyRightColumn.init("#adcontainer_column-right", "#column-left");
            }
        } else if (PageMetadata.reqHeaders.device === "MOBILE" || breakpoint === 1) {
            if(!Medscape._isODP && (typeof fpfMeta == 'undefined' || !fpfMeta['isFPF'])){
                scrollEvents.init();
				document.addEventListener('switchContent', function(e) {
					if (currSlctCont.indexOf('http') != -1) {
						trackurl = currSlctCont;	
					} else {
						trackurl = window.location.protocol + '//' + window.location.hostname + currSlctCont;
					}
                    
					scrollEvents.init();
				});

                document.addEventListener('newFeedContentLoaded', function(e) {
                    lazyloadingImages.init(e.detail.contUrl);  
                    embedTweets();
				});

                document.addEventListener('switchContent', load1523);

                document.addEventListener('newFeedContentLoaded', function() {			
					// Add element context to inline function calls
					document.querySelectorAll('[href*="showModal"]').forEach(function(elem) {
						let origHref = elem.href;
						elem.addEventListener('click', function() {
							showModal(origHref.match(/showModal\(['"]([^'"]+)['"]\)/)[1], elem);
						})
						elem.href = 'javascript:void(0)';
					});
				});

                if(window.textDriverOptimized){    
                    scroll1420Events.init();
                }
            }
            
            if($(".mobile_adlabelleft").length > 0) stickyHead.init();
        }

        $(window).resize(function() {
            if (breakpoint === 1) {
                $("#ads-pos-101").hide();
                $(".adSpcHolder").addClass("hide-141-ad");
            } else {
                $("#ads-pos-101").show();
                $(".adSpcHolder").removeClass("hide-141-ad");
            }

            profads.ads2.ResizeTextAds();
        });
    }
    // IFI ad for ArmsLength     
    if (armsLengthVariants.includes(PageMetadata.pageSegVars.ctype)) {
        if (breakpoint === 1) { 
        $('#rel-links').before($('#ads-pos-1909')); 
        } else {
        $('#mostPopRight').before($('#ads-pos-909')); 
        }
    }

    if (breakpoint === 1) {
        $(".adSpcHolder").addClass("hide-141-ad");
        //   adding 1909 ad for ismdAngle , ismdAffairs (for mobile view) - PPE-328023
        if(window._ismdAngle || window._ismdAffairs){
            if($('#article-content').children()[0].localName ==="p"){
                $('#article-content>p:nth-child(1)').after($('#ads-pos-1122'));
                $('#ads-pos-1122').after($('<div id="ads-pos-1909" class="AdUnit"></div>'));
                webmd.ads2.defineAd({
                    id: 'ads-pos-1909',
                    pos: '1909'
                });                 
            } 
        }
    }
});


function getPageNumber() {
    var _pathname = window.location.pathname.split("/");
    var _articleUrl = _pathname.length > 0 ? _pathname[_pathname.length - 1]: "";
    var _pageNum = _articleUrl && _articleUrl.split("_")[1] ? _articleUrl.split("_")[1] : "0";
    return parseInt(_pageNum);
}
// emailthis setup
$().ready(function() {
   
   function loadSendMsg() {
		if (typeof sendMsgInit == 'undefined') {
			var sendMsgJs = document.createElement('script');
			sendMsgJs.onload = function() {		
					sendMsgInit({ // adjust options per template if needed
						pubName: emailThis.publicationName,
						pubDate: emailThis.publicationDate
					});
			};
			document.body.appendChild(sendMsgJs);
			sendMsgJs.src = 'https://img.' + getDomain() + 'medscapestatic.com/medscape-core/common/js/send-msg/send-msg.js';
		} else {
			sendMsgInit();
		}
	}
	var loadSendMsgClickHandler = document.querySelector('.action-items .email');
    if(loadSendMsgClickHandler) {
        loadSendMsgClickHandler.addEventListener('click', loadSendMsg); // adjust selector as needed  
    }
   
});

$().ready(function() {
    if (getParameterByName('fpf') === '1' && qrllog === '0' && isMobile()) {
        setUpFPFLogin();
    }
});

function setUpFPFLogin() {
    var articleContent = $('#article-content');
    var secondParagraph = articleContent.find('p:not([class])').eq(1);

    // For second paragraph, show the first sentence and replace the last word with '...'
    var newText = secondParagraph.text().split(/[\w\s]{5,}\. /)[0].split(' ').slice(0, -1).join(' ') + '...';
    secondParagraph.text(newText);

    secondParagraph.nextAll().remove();
    articleContent.nextAll().hide();
    articleContent.parents().nextAll().hide();
    $('#layersContainer').show();

    // 50 is the height of top ad, which will appear after page load; 20 is widget padding
    var widgetHeight = $(window).height() - $('body').height() - 70;

    var login = $('<div id="mlogin" class="fpf-login-widget">' +
        '<div class="widget-title">To Continue Reading...</div>' +
        '<a class="widget-login" href="https://login.' + window.getDomain() + 'medscape.com/login/sso/getlogin" onClick="wmdTrack(\'fpf-login-layer_login\')">Login</a>' +
        '<div><span class="widget-text">Not a member? </span>' +
        '<a class="widget-signup" href="https://profreg.' + window.getDomain() + 'medscape.com/px/registration_ab.do?lang=en" onClick="wmdTrack(\'fpf-login-layer_reg\')">Sign up for a <strong>FREE</strong> account</a></div>' +
        '<img src="//img.medscapestatic.com/pi/logos/mscp-logo.png" class="widget-logo">' +
        '</div>');

    $('body').append(login);
    login.css('min-height', widgetHeight);

    var showed = false;
    $(window).on('scroll', function() {
        if (elementInViewport('mlogin') && !showed) {
            login.animate({ opacity: 1 }, 500);
            wmdTrack('fpf-login-layer-imp', 1);
            showed = true;
        }
    }).trigger('scroll');
}

function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function elementInViewport(el) {
    el = document.getElementById(el);
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
}

function isMobile() {
    var check = false;
    (function(a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

/* (START) Sticky Header 1004 Ad */
if (breakpoint == 1) {
    (function($) {
        function StickyMobileHead() {
            this.stopStickyTime = 5000;
            this._timerHandler = this.timerHandler.bind(this);
        }

        StickyMobileHead.prototype.init = function() {
            var self = this;
            this.$adtagheader = $(".mobile_adlabelleft");
            this.$window = $(window);
            this.originalAdHeight = this.$adtagheader.outerHeight() + 50;
            this.originalTopAdTop = this.$adtagheader.offset().top;
            webmd.ads2.addSlotRenderEndedCallback("ads-pos-1004", this._timerHandler);
            $(document).on("animationOffStickStep", function() {
                var top = $("#ads-pos-1004").outerHeight(true);
                if (top <= 0) top = 0;
                $("#article-nav.fixed-sticky").css("top", top + "px");
            });
            this.addSticky();
        };

        StickyMobileHead.prototype.timerHandler = function() {
            var self = this;
            var timerid = setTimeout(function() {
                self.animationOffSticky();
                clearTimeout(timerid);
            }, this.stopStickyTime);
        };

        StickyMobileHead.prototype.isSticky = function() {
            var pos = $("#headerbox").offset().top + $("#headerbox").outerHeight(true);
            return (this.$adtagheader.offset().top > pos);
        };

        StickyMobileHead.prototype.addSticky = function() {
            this.$adtagheader.addClass("stickyHeader");
            $("body").addClass("stickyHeader");
            $(document).trigger("addSticky");
        };

        StickyMobileHead.prototype.removeSticky = function() {
            this.$adtagheader.removeClass("stickyHeader");
            $("body").removeClass("stickyHeader");
        };

        StickyMobileHead.prototype.animationOffSticky = function() {
            var self = this;
            if (this.isSticky()) {
                $("#ads-pos-1004").slideUp({
                    duration: "slow",
                    step: function() {
                        $(document).trigger("animationOffStickStep");

                    },
                    complete: function() {
                        self.removeSticky();
                        $("#ads-pos-1004").show();
                    }
                }); // end slideUp()
            } // end if
            else self.removeSticky();
        };

        StickyMobileHead.prototype.disableSticky = function() {
            this.removeSticky();
        };
        // create a new instance
        stickyHead = new StickyMobileHead();
    }($));
} // end if(breakpoint==1)
/* (END) Sticky Header 1004 Ad */

function coeFooter() {
    if (!$('#coe-footer').length || (typeof mscpA2A == 'boolean' && mscpA2A)) return;

    var title = leadconceptName.trim().toLowerCase();
    var featuredURL = '//img.' + getDomain() + 'medscapestatic.com/medscape-files/coe/' + title.replace(/\+/g, ' ') + '.json';
    var sourceMarker = 'sapfe';
    title = title.charAt(0).toUpperCase() + title.slice(1);

    var smallIFI = void 0,
        largeIFI = void 0;
    if (breakpoint === 1) {
        smallIFI = '<div id="ads-pos-1420-sfp" class="AdUnit AdUnit-sfp"></div>';
        largeIFI = '<div id="ads-pos-1712-sfp" class="AdUnit AdUnit-sfp"></div>';
    } else {
        smallIFI = '<div id="ads-pos-420-sfp" class="AdUnit AdUnit-sfp"></div>';
        largeIFI = '<div id="ads-pos-142-sfp" class="AdUnit AdUnit-sfp"></div>';
    }

    $.get(featuredURL).done(function(data) {
        title = data.footer.title || title;
        var link = data.footer.link || '//www.' + getDomain() + 'medscape.com/resource/' + title.toLowerCase();
        var ajaxs = [];
        for (var i = 0; i < data.footer.buckets.length; i++) {
            var jsonp = $.ajax({
                type: "GET",
                url: '//api.' + getDomain() + 'medscape.com/servicegateway/v1/bucketgenservice/bucketgenservice/v1/getFragment?bucketId=' +
                    data.footer.buckets[i].bucketId + '&renderingId=' + data.footer.buckets[i].renderId,
                dataType: 'jsonp'
            });
            ajaxs.push(jsonp);
        }

        $.when.apply(null, ajaxs).done(function() {
            var footer = '<h5 class="rel-links-title"><div class="rel-subtitle">MORE FROM THE</div><a href="' + link + '" class="rel-coe-link">' + title + '</a><div class="rel-subtitle">CENTER OF EXCELLENCE</div></h5><section class="coe-featured"><ul>';
            var resps = Array.prototype.slice.call(arguments);

            for (var i = 0; i < data.Featured.length && i < 4; i++) {
                var content = data.Featured[i];
                var video = content.video ? '<span class="imgVideo"></span>' : '';
                var videoClass = content.video ? 'eleVideo' : '';
                var logo = content.logo ? '<img class="colab-logo-inline" src="' + content.logo + '">' : '';
                footer += '<li><a class="' + videoClass + '" href="' + content.link + '?src=' + sourceMarker + '" onclick="wmdTrack(\'coe-af_' + (i + 1) +
                    '\')"><img src="https://img.' + window.getDomain() + '.medscapestatic.com/pi/global/1x1.png" data-src="' + content.thumb + '?interpolation=lanczos-none&resize=360:*" data-alt="' + content.alt + '">' + video +
                    '</a><div><div class="tag callouttag"><span class="tag-text">' + content.pub + '</span>' + logo +
                    '</div><a href="' + content.link + '?src=' + sourceMarker + '" onclick="wmdTrack(\'coe-af_' + (i + 1) +
                    '\')"><div class="title">' + content.title + '</div></a></div></li>';
                if (i === 1) {
                    footer += smallIFI;
                }
            }

            footer += '</ul></section><section class="coe-middle">' +
                '<div class="coe-ad">' + largeIFI + '</div>' +
                '<div class="coe-editorials">';

            for (i = 0; i < resps.length; i++) {
                footer += '<div class="coe-editorial"><div class="section-title">' + data.footer.buckets[i].title + '</div><ul>' + resps[i][0].fileFragments[0] + '</ul></div>'
            }

            footer += '</div></section><div class="coe-link-wrapper"><a class="coe-link" href="' + link + '">More on ' + title + '</a></div>';

            $('#coe-footer').append(footer);
            $('.coe-editorial li').each(function() {
                var $anchor = $(this).find('a');
                var href = $anchor.attr('href');
                $anchor.attr('href', href + '?src=' + sourceMarker).attr('onclick', 'wmdTrack("coe-af_' + ++i + '")');
            });
            setTimeout(function() {
                loadCOEads();
                adjustCOEcol();
            }, 250);
            vfCommentCount();
            lazyloadingImages.init();
        });
    });
}

function loadCOEads() {
    if (breakpoint === 1) {
        webmd.ads2.sizes[1712] = [
            [2, 4],
            'fluid'
        ];
        webmd.ads2.sizes[1420] = [
            [2, 4],
            'fluid'
        ];
        webmd.ads2.setPageTarget('ll', '1');
        if(document.getElementById('fpfAdsSuppress') != null && document.getElementById('fpfAdsSuppress').value.split(',').indexOf('1420') != -1){
            ads2_ignore[1420] = false;
        }
        webmd.ads2.defineAd({id:"ads-pos-1420-sfp", pos:1420, sizes:[2,4]}).refresh({id:'ads-pos-1420-sfp'});
        webmd.ads2.defineAd({id:"ads-pos-1712-sfp", pos:1712, sizes:[2,4]}).refresh({id:'ads-pos-1712-sfp'});

    } else {
        webmd.ads2.sizes[141] = [
            [728, 90],
            [728, 91],
            'fluid'
        ];
        webmd.ads2.sizes[142] = [
            [2, 4],
            [300,250],
            'fluid'
        ];
        webmd.ads2.sizes[420] = [
            [ 2, 4 ],
            'fluid'
        ];
        
        webmd.ads2.setPageTarget('ll', '1');
        if(document.getElementById('fpfAdsSuppress') != null && document.getElementById('fpfAdsSuppress').value.split(',').indexOf('420') != -1){
            ads2_ignore[420] = false;
        }
        webmd.ads2.defineAd({id:"ads-pos-420-sfp", pos:420, sizes:[2,4]}).refresh({id:'ads-pos-420-sfp'});
        webmd.ads2.defineAd({id:"ads-pos-142-sfp", pos:142, sizes:[[2,4], [300,250]]}).refresh({id:'ads-pos-142-sfp'});
    }
}

function adjustCOEcol() {
    $(document).one('dfpRenderComp', function() {
        if (breakpoint === 1) {
            var coeFallback = $('#ads-pos-1712-sfp');
        } else {
            var coeFallback = $('#ads-pos-142-sfp');
        }
        setTimeout(function() {
            if ($(coeFallback).length > 0) {
                if (!$(coeFallback).closest('section').hasClass('has-ad') && !$(coeFallback).hasClass('blank-ad')) {
                    $(coeFallback).closest('section').addClass("has-ad has-ad-label");
                }
            }
        }, 1000);
    })
}

function embedTweets() {
	$('oembed:contains(//twitter.com)').each(function() {
		var self = this;
        let url;
        const twitterURl = $(this).html().trim();
        if(twitterURl.indexOf('publish.twitter.com/oembed') !== -1) {
            url = twitterURl;
        }else {
            url = 'https://publish.twitter.com/oembed?url=' + encodeURIComponent($(this).html().trim());
        }
		$.ajax({
			url,
			jsonp: 'callback', 
			dataType: 'jsonp',  
			success: function(json) {
				$(self).replaceWith(json.html);
			}
		});
	});
}


// Video IFI Text Ad - moved from 'medscape-corelib.js' per PPE-210821
var vidIfiTxtAd;
vidIfiTxtAd = window.vidIfiTxtAd || {};
vidIfiTxtAd = {
    vidIfiTxtAdSettings: {
        ifiKey: true,
        ifiRender: true
    },
    isPlayingFunc: function () {
        var targetVidNode = $('#videoContent video.akamai-html5');
        $(targetVidNode).on("play", function () {
            vidIfiTxtAd.render();
        });
    },
    ifiKeySet: function (booSet) {
        if (booSet) {
            vidIfiTxtAd.vidIfiTxtAdSettings.ifiKey = true;
        } else { vidIfiTxtAd.vidIfiTxtAdSettings.ifiKey = false; }
    },
    render: function () {
        if (vidIfiTxtAd.vidIfiTxtAdSettings.ifiRender) {
            vidIfiTxtAd.vidIfiTxtAdSettings.ifiRender = false;
            var tempTxtAdId;
            var pageTypeTime;
            var styleTag = document.createElement('link');
            styleTag.setAttribute('type', 'text/css');
            styleTag.setAttribute('rel', 'stylesheet');
            styleTag.setAttribute('href', 'https://img.' + getDomain() + 'medscapestatic.com/medscape-core/shared-all/css/vid-ifi-txt-driver.css');
            document.getElementsByTagName("head")[0].appendChild(styleTag);
            if (PageMetadata.reqHeaders.domain == "reference") {
                pageTypeTime = 8500;
            } else { pageTypeTime = 28500; }
            setTimeout(function(){
                $('<div id="ads-pos-820" style="display: none"></div>').insertBefore( '#videoContent #cme-video-player:first');
                webmd.ads2.defineAd({
                    id: 'ads-pos-820',
                    pos: '820',
                    immediate: true,
                    collapseAfter: true
                });
                setTimeout(function () {
                    if ($('#ads-pos-820').length > 0) {
                        var pos820ifrm = $('#ads-pos-820 iframe');
                        if (pos820ifrm.contents().find(".video-violator-type-text").length > 0) {
                            tempTxtAdId = document.getElementById($('#ads-pos-820 iframe').attr('id')).contentWindow.adEcid;
                            var vidTextDriver = pos820ifrm.contents().find(".video-violator-type-text");
                            $(vidTextDriver).insertBefore( '#videoContent #cme-video-player:first');
                            setTimeout(function () {
                                var vvAnchor = $('.video-violator-type-text .ifi-promo-txt');
                                var vvHref = vvAnchor.attr('href');
                                if (vvHref.indexOf('?') !== -1 ){
                                    vvAnchor.attr('href', vvHref+'&src=ad_videopeek')
                                } else {
                                    vvAnchor.attr('href', vvHref+'?src=ad_videopeek')
                                }
                                $('.video-violator-type-text').bind( 'click', function() {
                                    wmdTrack('vdrvr-'+tempTxtAdId+'_open');
                                });
                            }, 250);
                        }
                    }
                }, 500);
                setTimeout(function(){
                    vidIfiTxtAd.toggleIfiPromo();
                }, 1500);
            }, pageTypeTime);
        }
    },
    toggleIfiPromo: function () {
        if (vidIfiTxtAd.vidIfiTxtAdSettings.ifiKey) {
            vidIfiTxtAd.ifiKeySet(false);
            if ( $('.ifi-promo').length ) {
                var ifiPromo = $('.ifi-promo');
            } else if ( $('.ifi-promo-non').length ) {
                var ifiPromo = $('.ifi-promo-non');
            }
            var vidTxtAdId = document.getElementById($('#ads-pos-820 iframe').attr('id')).contentWindow.adEcid;
            var ifiPromoClose = $('.ifi-promo-close');
            var ifiPromoCloseAnchor = $('.ifi-promo-close a');
            var ifiPromoContents = $('.ifi-promo-contents');

            if (ifiPromo.hasClass('ifi-closed')) {
                ifiPromo.removeClass('hide-vv');
                ifiPromo.removeClass('video-violator-collapsed').removeClass('ifi-closed').addClass('video-violator');
                ifiPromoClose.addClass('fade-out');
                ifiPromoCloseAnchor.removeClass('open-x').addClass('close-x');
                setTimeout(function() {
                    ifiPromoContents.removeClass('collapsed');
                    ifiPromoClose.removeClass('black-out').removeClass('fade-out');
                    vidIfiTxtAd.ifiKeySet(true);
                    wmdPageLink('vdrvr-'+vidTxtAdId+'_imp');
                }, 2000);
            } else {
                wmdPageLink('vdrvr-'+vidTxtAdId+'_x');
                ifiPromo.addClass('video-violator-collapsed').addClass('ifi-closed').removeClass('video-violator');
                ifiPromoClose.addClass('black-out');
                ifiPromoCloseAnchor.addClass('open-x').removeClass('close-x');
                ifiPromoContents.addClass('collapsed');
                setTimeout(function() {
                    ifiPromo.addClass('hide-vv');
                    vidIfiTxtAd.ifiKeySet(true);
                }, 2000);
            }
        }
    }
};

// Article Video Launcher - moved from 'medscape-corelib.js' per PPE-210821
var artVidLaunch = {
	"addBundle": function (json, videoEl) {
		var vidConfigObj = json; // Fast Video
		var fastVidBool = true;
		var tracking = {"moduleName": "vidodp", "toolin": "video - odp"};	
		
		if (typeof json.config != 'undefined') {
			vidConfigObj = json.config;
			fastVidBool = false;
		}
		
		vidConfigObj['videoId'] = 'video1';
		
		/* Mappings for ODP video */
		if (!fastVidBool) {
			if (typeof vidConfigObj['poster'] != 'undefined') {
				vidConfigObj['poster'] = vidConfigObj['poster'].replace('en/pi','pi');
			}
			if (typeof vidConfigObj['bumperImage'] != 'undefined') {
				vidConfigObj['bumperImage'] = vidConfigObj['bumperImage'].replace('en/pi','pi');
			}
			if (typeof s_sact !== "undefined") {
				tracking['activityId'] = s_sact.toString();
			}
		}
		/* /End Mappings for ODP video */
		
		/* Mappings for Fast Video media Object */
		if (fastVidBool) {
			tracking = {"moduleName": "vidfv", "toolin": "video - fv"};
			if (typeof vidConfigObj['media-location'] != 'undefined') {
				vidConfigObj['source'] = vidConfigObj['media-location'];
			}
			if (typeof vidConfigObj['start-image'] != 'undefined') {
				vidConfigObj['poster'] = vidConfigObj['start-image'];
			}
			if (typeof vidConfigObj['end-image'] != 'undefined') {
				vidConfigObj['bumperImage'] = vidConfigObj['end-image'];
			}
			if (typeof vidConfigObj['autoplay'] == 'string') {
				if (vidConfigObj['autoplay'] == "F") {
					vidConfigObj['autoplay'] = false;
				} else if  (vidConfigObj['autoplay'] == "T") {
					vidConfigObj['autoplay'] = true;
				} else {
					vidConfigObj['autoplay'] = false;
				}
			}		
			if (typeof vidConfigObj['duration'] == 'string' && vidConfigObj['duration'].indexOf(':') != -1) {
				var durValue = 0;
				var durArray = vidConfigObj['duration'].split(':');
				if (durArray.length == 3) {
					durValue += Number(durArray[0])*3600;
					durValue += Number(durArray[1])*60;
					durValue += Number(durArray[2]);
				} else if (durArray.length == 2) {
					durValue += Number(durArray[0])*60;
					durValue += Number(durArray[1]);
				}
				vidConfigObj['duration'] = durValue.toString();
			}
		}
		/* /End Mappings for Fast Video media Object */
		
		if (typeof json.tracking != 'undefined' && Object.keys(json.tracking).length > 0) {
			$.extend(true, tracking, json.tracking);
		}
		if(!document.getElementById('fast-video')) {
            var bundleJS = document.createElement('script');
            document.getElementsByTagName("body")[0].appendChild(bundleJS);
            bundleJS.onload = function() {
                window.myVideoPlayer = new Medscape.modules.StreamingVideoPlayer(videoEl, vidConfigObj, tracking);
                window.myVideoPlayer.create().then(event => {
                    videoEl.classList.add('video-loaded');
                });
            };
            bundleJS.id = 'fast-video';
            bundleJS.src = '//img.' + getDomain() + 'medscapestatic.com/medscape-promo/streaming-video-player/js/streaming-video-player.bundle.js';
        }
    },
	
	"init": function() {
        // NON-FAST-VID
		var videoEl = document.getElementById('cme-video-player');
		if (videoEl != null && videoEl.getAttribute('data-config') != null && videoEl.getAttribute('data-config') != '' && document.getElementById('video-bundle') == null) {
			
			if (document.domain.indexOf('decisionpoint.') != 0) { // NOT ODP - add Event Listeners for vidIfiTxtAd
				var ipadDeviceCheck = '',
					reqDomainCheck = '';		
				if (typeof PageMetadata !== "undefined" && typeof PageMetadata.reqHeaders !== "undefined" && typeof PageMetadata.reqHeaders.device !== "undefined") {
					if (PageMetadata.reqHeaders.device == 'IPAD') {
						ipadDeviceCheck = 'IPAD';
					}
				}	
				else {
					if (navigator.userAgent.match(/iPad/i) != null) {
						ipadDeviceCheck = 'IPAD';
					}
				}		
				if (typeof PageMetadata !== "undefined" && typeof PageMetadata.reqHeaders !== "undefined" && typeof PageMetadata.reqHeaders.domain !== "undefined") {
					if (PageMetadata.reqHeaders.domain.indexOf('reference') !== -1) {
						reqDomainCheck = 'reference';
					}
				}
				else {
					if(window.location.href.indexOf("reference.") !== -1) {
						reqDomainCheck = 'reference';
					}
				}	
				if ((!isMobile || profads.ads2.getBrkPnt() !== '320-767') && ipadDeviceCheck !== 'IPAD') {
					if (reqDomainCheck == 'reference') {
						// Listen for the react player create event.
						window.addEventListener('onplayercreate', function(e) {
							vidIfiTxtAd.isPlayingFunc();
						}, false);
					} else if ($('#article-content .AdUnit').length > 0 || $('#article-content .inContentAd').length > 0) {
						// Listen for the react player create event.
						window.addEventListener('onplayercreate', function(e) {
							vidIfiTxtAd.isPlayingFunc();
						}, false);
					}			
				}
			}			
		}
		
		// FAST-VID		
		if ($('.streaming-video-container').length > 0 && typeof fastVidCfg == 'object') {
			artVidLaunch.addBundle(fastVidCfg, $('.streaming-video-container')[0]);
		}		
	}	
};

function overlapfix(){
    $(window).on('load',function(){ 
        if( _isRecap){
            if($('#ads-pos-910').length > 0){
                
                if(($('#ads-pos-910').offset().top + $('#ads-pos-910').outerHeight()) >  $('#rel-links-container').offset().top){
                     $('#column-left.article-column-left').css("margin-bottom", $('#ads-pos-910').offset().top + $('#ads-pos-910').outerHeight(true) - $('#rel-links-container').offset().top + "px");
    
                }
            }
        }
    });
}
if (typeof addBundle == 'undefined') { // Check for presence of 'medscape-corelib.js', for cutover, check may be removed post launch
	artVidLaunch.init();
}

//Learning 2.0 - cme layer for related links

function cmeLayer(url) {
    document.addEventListener('click', function (e) {
        if ((e.target.id === 'cme-overlay') || (e.target.id === 'cme-popup-close')) {
            clearTimeout(cmeTimer);
            document.getElementById('cme-overlay').classList.remove("active");
            document.getElementById('cme-popup').classList.remove("active");
            document.getElementsByClassName("progress-inner")[0].style.animation = '';
            document.getElementsByClassName("progress-inner")[0].style.animationFillMode = '';
        }
    }, false);
    let cmeTimer;
    $('#cme-overlay').addClass('active');
    $('#cme-popup').addClass('active');
    document.getElementsByClassName("progress-inner")[0].style.animation = 'animateThis 6s';
    document.getElementsByClassName("progress-inner")[0].style.animationFillMode = 'forwards';
    cmeTimer = setTimeout(function() {
        window.location.href = url;
    }, 5000);
}

//end of Learning 2.0

//PPE-289272 - Community: Profile Hover
//set up for hover is in the initialRenderComplete livefyre code

//function to format date for community profile hover
var monthNames = ["January", "Febuary", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

function profileDateFormat(d){
    var t = new Date(d.replace(/ /g,"T"));
    return monthNames[t.getMonth()] + ' ' + t.getFullYear();
}
//community profile hover functionality called on hover of comment user name
//userSibling is the first sibling of the username the user is hovering on
function profileHover(userSibling) {
	
	/* COMMENTING OUT PROFILEHOVER UNTIL VIAFOURA-BASED SOLUTION IDENTIFIED
		
    //livefyre author id
    var authorId;
    var fullAuthorId;
    fullAuthorId = $(userSibling).closest('.fyre-comment-article').attr('data-author-id');
    authorId = $(userSibling).closest('.fyre-comment-article').attr('data-author-id');
    authorId = authorId.substr(0, authorId.indexOf('@'));

    //if the profile card for a comment already exists, show it
    if ($(userSibling).closest('.fyre-comment-head').children('.profile-card').length > 0) {
        $(userSibling).closest('.fyre-comment-head').children('.profile-card').show();
    }
    //if the user already has a comment with the profile card, duplicate the profile card and append to this comment
    else if ($("[data-author-id='" + fullAuthorId + "']").find('.profile-card').length > 0) {
        var clonedCard = $("[data-author-id='" + fullAuthorId + "']").find('.profile-card').first().clone();
        if (breakpoint === 3 || breakpoint ===4) {
            $(clonedCard).css('display', 'flex');
        }
        else {
            $(clonedCard).css('display', 'block');
        }
        $(userSibling).after(clonedCard);
    }

    //otherwise call communityProfile
    else {
        $.ajax({
            type:"POST",
            url: "//api." + getDomain() + "medscape.com/servicegateway/communityProfile",
            dataType: 'json',
            data: JSON.stringify({
                guid: authorId,
            }),
            crossDomain: 'true',
            contentType: 'application/json',
            xhrFields: {
                withCredentials: true
            },
            success:function(data) {
                //create main card
                var profileCard = document.createElement('section');
                profileCard.setAttribute('class', 'profile-card');

                //create rest of profile
                profileCard.innerHTML = '<span class="profile-avatar"></span>\n' +
                    '\t<div class="profile-info">\n' +
                    '\t\t<span class="profile-author"></span>\n' +
                    '\t\t<span class="profile-profession"></span>\n' +
                    '\t\t<span class="profile-specialty"></span>\n' +
                    '\t\t<span class="profile-location"></span>\n' +
                    '\t\t<span class="profile-date"></span>\n' +
                    '\t</div>\n' +
                    '\t<div class="close-btn"><a href="#">X</a></div>';

                $(userSibling).after(profileCard);

                //place profileCard after the username's sibling element
                if (!$(userSibling).parent().hasClass('show-card')) {
                    $(profileCard).hide();
                }
                else {
                    $(profileCard).show();
                }

                //mobile logic to give close-btn event needs to be copied here
                if (breakpoint < 3) {
                    //on click of close button, hide the profile card and greyoutlayer
                    $(document).on("click", '.profile-card .close-btn', function() {
                        $(this).parent().removeClass('show-card');
                        $(this).closest('.fyre-comment-head').children('.profile-card').hide();
                        $('#greyoutlayer').hide();
                    });
                }

                //use data from ajax call to fill in profile card
                $(profileCard).children('.profile-avatar').html(data.profile.fn.charAt(0) +  data.profile.ln.charAt(0));
                if (data.profile.degdesc !== null && data.profile.degdesc !== "") {
                    $(profileCard).find('.profile-author').html(data.profile.fn + ' ' + data.profile.ln +', ' + data.profile.degdesc);
                }
                else {
                    $(profileCard).find('.profile-author').html(data.profile.fn + ' ' + data.profile.ln);
                }
                if (typeof data.profile.profdesc !== 'undefined' && data.profile.profdesc !== '') {
                    $(profileCard).find('.profile-profession').html(data.profile.profdesc);
                }
                if (typeof data.profile.spdesc !== 'undefined' && data.profile.spdesc !== '' && data.profile.spdesc !== 'None') {
                    $(profileCard).find('.profile-specialty').html(data.profile.spdesc);
                }
                if (data.profile.stdesc !== null && data.profile.stdesc !== "" && data.profile.codesc !== null && data.profile.codesc !== "") {
                    $(profileCard).find('.profile-location').html(data.profile.stdesc + ', ' + data.profile.codesc);
                }
                else if (data.profile.stdesc !== null && data.profile.stdesc !== "") {
                    $(profileCard).find('.profile-location').html(data.profile.stdesc);
                }
                else {
                    $(profileCard).find('.profile-location').html(data.profile.codesc);
                }
                if (typeof data.profile.crdt !== 'undefined' && data.profile.crdt !== '') {
                    $(profileCard).find('.profile-date').html('Member Since ' + profileDateFormat(data.profile.crdt));
                }
            }
        });
    }

    //commenting layer "x" should also close greyoutlayer and clear profile cards
    $('.layer-header svg').click(function() {
        $('#greyoutlayer').hide();
        $('.profile-card').hide();
    });

    //tracking call
    wmdPageLink('uc-prof_hover');
	
	*/
	
}
//End of Community Profile Hover

	//Right Rail Recirculation Widget starts
    function addRecirculationWidget(){
        var recirSlot1 = 632;
        var recirSlot2 = 633;
        
        if(detectDevice() === 'mobile'){
            recirSlot1 = 1632;
            recirSlot2 = 1633;
        }
        var slot1Html = '<li id="ads-pos-' + recirSlot1 + '" class="AdUnit"></li>';
        var slot2Html = '<li id="ads-pos-' + recirSlot2 + '" class="AdUnit"></li>';
            
        //news article page
        if ( (/\/viewarticle\//).test(location.pathname)) {
                var checkRecommendations = $('#rel-recommend');
                if(checkRecommendations.length != 0){
                    var recommendations = $('#rel-recommend li');                                            
                    if(recommendations.length > 3){
                        var ad622 = document.getElementById('ads-pos-622');
                        if(ad622 !== 'undefined' && ad622 !== null && $(ad622).hasClass('blank-ad')){
                            recommendations[4] ?  recommendations[4].style.display = 'none' : console.log("4th li is not there");
                            recommendations[5] ?  recommendations[5].style.display = 'none' : console.log("5th li is not there");
                         
                        // }else if(ad622 !== 'undefined' && ad622 !== null && !$(ad622).hasClass('blank-ad')){
                        //     recommendations[3] ?  recommendations[3].style.display = 'none' : console.log("3th li is not there");
                        //     recommendations[4] ?  recommendations[4].style.display = 'none' : console.log("4th li is not there");
                        }else{
                            recommendations[3] ?  recommendations[3].style.display = 'none' : console.log("3th li is not there");
                            recommendations[4] ?  recommendations[4].style.display = 'none' : console.log("4th li is not there");
                            recommendations[5] ?  recommendations[5].style.display = 'none' : console.log("4th li is not there");
                        }
                    }    
                    
                    var liIndex632 = recommendations.length-2;
                    var liIndex633 = recommendations.length-1;
                    recommendations.eq(liIndex632).after(slot1Html);
                    webmd.ads2.defineAd({
                        id: 'ads-pos-' + recirSlot1,
                        pos: recirSlot1
                    });                    
                    
                    recommendations.eq(liIndex633).after(slot2Html);
                    webmd.ads2.defineAd({
                        id: 'ads-pos-' + recirSlot2,
                        pos: recirSlot2
                    });    
                    
                }
                var adcontainer1 = document.getElementById('ads-pos-' + recirSlot1);
                var adcontainer2 = document.getElementById('ads-pos-' + recirSlot2);
                if(adcontainer1 !== undefined && adcontainer1 !== null){
                    adcontainer1.className += ' ' + 'adlabelblank'
                    adcontainer1.style.paddingTop = '10px';
                    // if (adcontainer1.style.display === 'none' || $(adcontainer1).hasClass('blank-ad')) {
                    //     recommendations.eq(liIndex632).style.display = 'none';
                    // }
                    // if(adcontainer1 !== null && ($(adcontainer1).hasClass('blank-ad')) || adcontainer1.childNodes[0].children.length === 0)){
                    //     adcontainer1.style.display='none';
                    // }
                    
                }
                if(adcontainer2 !== undefined && adcontainer2 !== null){
                    adcontainer2.className += ' ' + 'adlabelblank';
                    adcontainer2.style.paddingTop = '10px';
                    // if (adcontainer2.style.display === 'none' || $(adcontainer2).hasClass('blank-ad')) {
                    //     recommendations.eq(liIndex633).style.display = 'none';
                    // }
                    // if(adcontainer2 !== null && ($(adcontainer2).hasClass('blank-ad'))){
                    //     adcontainer2.style.display='none';
                    // } 
                }   
                
                window.addEventListener('load', (event) => {
                    console.log('DOM fully loaded and parsed');
                    setTimeout(function(){
						var loaded632 = false;
						var loaded633 = false;
						if (adcontainer1 != null && adcontainer1.childNodes.length > 0) {
							loaded632 = adcontainer1.childNodes[0];
						}
						if (adcontainer2 != null && adcontainer2.childNodes.length > 0) {
							loaded633 = adcontainer2.childNodes[0];
						}
                        if(adcontainer1 !== null && loaded632 && ($(adcontainer1).hasClass('blank-ad')||adcontainer1.children.length === 0||adcontainer1.childNodes[0].children.length === 0)){
                            adcontainer1.style.display='none';
                        }
                        if(adcontainer2 !== null && loaded633 && ($(adcontainer2).hasClass('blank-ad')||adcontainer1.children.length === 0||adcontainer1.childNodes[0].children.length === 0)){
                            adcontainer2.style.display='none';
                        } 
                     }, 8000);
                   
                });
        }
    }
	if (typeof mscpA2A == 'undefined') {
		$(document).ready(addRecirculationWidget);
	}
    //Right Rail Recirculation Widget ends



    var scrollLazyEvents = {
        classInConAd: $(".lazy"),
        init: function() {
            breakpoint === 1 ?  $('div[id^="ads-pos-1122"]').addClass("lazy") : $('div[id^="ads-pos-141"]').addClass("lazy");
            
            $(window).on("scroll", function() {
               let adLazyLoadEvent = setTimeout("scrollLazyEvents.adLazyLoad()", 250);
            });
        },
        adLazyLoad: function() {
            //console.log("scroll");
            let classInConAd = $(".lazy");
            classInConAd.each(function(i, el){
                //console.log("i'm inside1","#"+$(this).attr('id'));
                const parent = $(this).parent();
                const isplcHold141 = parent.attr('id') == 'plcHold-141';
                if(scrollEvents.scrollIntoView(isplcHold141 ? parent : el)){
                    //console.log("i'm inside1",$(this).attr('id'));
                    if($(this).attr('id') == 'ads-pos-141'){
                        if($(this).parent().attr('id') == 'plcHold-141'){
                            if(scrollEvents.scrollIntoView("#plcHold-141")){
                                 window.ads2_ignoreIds['ads-pos-141'] = false;
                            }
                            else{
                                return;
                            }
                        }
                    }
                    if(!$(this).eq(i).hasClass('lazyed')){
                        //console.log("i'm inside2");
                        $(this).addClass("lazyed").removeClass('lazy');
                        webmd.ads2.setPageTarget('ll', '1');
                        //console.log($(this).attr('id'));
                        if(breakpoint === 1){
                            window.ads2_ignore["1122"] = false;
                            profads.ads2.proclivityRefresh('ads-pos-1122', $(this).attr('id'));
                        }
                        else{
                            window.ads2_ignore["141"] = false;
                            webmd.ads2.defineAd({
                                id: $(this).attr('id'),
                                pos: '141',
                                immediate: true,
                                collapseAfter: true
                            });
                        }
                        // moving ad define into success for proclivityRefresh ajax call
                    }
                }
            });
        }
    }
    
    if(_isODP && (PageMetadata.webSegVars.pc =="content")){
        scrollLazyEvents.init();
    }
function setStickyAccordion() {
    $(document).on('click', '.accordion-wrapper .accordion > button#accordion-menu-open', function (e) {
        openAccordionMenu($(this));
        return false;
    });
    $(document).on('click', '#accordion-model a ', function (e) {
        let accrdionHeading =  $(e.target).text();
        let heading = accrdionHeading.replace(/[^\w-]+/g, '-').toLowerCase();
        wmdPageLink(`al-accordion-${heading}_expand-${heading}`,this);
        let headerEle = $('.accordion-section .accordion-heading');
        for (i = 0; i < headerEle.length; i++) {
            if ($(this).text() == headerEle[i].outerText) {
                $(this).parent().parent().parent().removeClass('active');
                headerEle[i].scrollIntoView();
                $(headerEle[i]).closest('.accordion-wrapper').addClass('active')
                $("body").css('overflow', 'auto');
                $('#accordion-menu-close').remove();
                $(this).parent().remove();

            }
        }
    })
    $(window).on('scroll', function (e) {
        e.stopPropagation();
        try {
            let scrollTop = $('html').scrollTop();
            let accordionSectionOffset = $('.accordion-section').offset().top;
            if (scrollTop >= accordionSectionOffset && scrollTop <= (accordionSectionOffset + $('.accordion-section').height())) {
                let wrappers = $('.accordion-section .accordion-wrapper.active');
                if (wrappers.length > 0) {
                    for (let i = 0; i < wrappers.length; i++) {
                        const ele = wrappers[i];
                        let wrapEleTop = $(ele).offset().top;
                        if (wrapEleTop <= scrollTop && (($('.accordion-section').offset().top + $('.accordion-section').height() - $(ele).height()) >= scrollTop
                            || ($('.accordion-section').offset().top + $('.accordion-section').height() - $(ele).next().height()) >= scrollTop)) {
                            if ($(ele).children(".accordion").children('button.menu-btn').length == 0) {
                                $(ele).children(".accordion").append("<button class='menu-btn' id='accordion-menu-open'></button>");
                            }
                        }
                        else if ($(ele) && (wrapEleTop > scrollTop || $(ele).next().offset().top - 100 <= scrollTop)) {
                            $(ele).children(".accordion").children('button').remove();
                        }
                    }
                }
            }
            else {
                let wrappers = $('.accordion-section .accordion-wrapper.active');
                if (wrappers.length > 0) {
                    for (let i = 0; i < wrappers.length; i++) {
                        const ele = wrappers[i];
                        if ($(ele).children(".accordion").children('button.menu-btn').length > 0) {
                            $(ele).children(".accordion").children('button').remove();
                        }
                    }
                }

            }
        }
        catch (err) {
            console.log('Scroll event handler failed: ' + err);
        }
        return false;
    })
}
function openAccordionMenu(ele) {
    $(ele).addClass('close');
    $(ele).attr('id', 'accordion-menu-close');
    $(document).on('click', '.accordion-wrapper .accordion > button#accordion-menu-close', function (e) {
        closeAccordionMenu($(this));
        return false;
    });
    let panelEle = $(ele).parent().siblings('.panel');
    let aEle = '';
    let divEle = '';
    let headerEle = $('.accordion-section .accordion-heading');
    for (i = 0; i < headerEle.length; i++) {
        let currentEle = "";
        if ($(ele).siblings().text() == headerEle[i].outerText) {
            currentEle += `<span class='accordion-icon'></span><span>${headerEle[i].outerText}</span>`
        }
        else
            currentEle += headerEle[i].outerText;
        aEle += "<a>" + currentEle + "</a>"
    }
    const _topPos = $('.accordion-wrapper.active .accordion').height() + 30;
    divEle += `<div id='accordion-model' style="top:${_topPos}px">${aEle}</div>`;
    divEle;
    panelEle.append(divEle);
    $('body').css("overflow", "hidden");
}
function closeAccordionMenu(ele) {
    $(ele).attr('id', 'accordion-menu-open');
    $(ele).removeClass('close');
    let panelEle = $(ele).parent().siblings('.panel')
    $('#accordion-model').remove();
    panelEle.css({ "height": "auto", 'overflow': 'auto' });
    $('body').css("overflow", "auto");

}

// article to article: collapse footer copyright and citation PPE-479956
$(document).on('click', '#legal_block, .article__footer', function(e) {
	var hadActive = $(this).hasClass('active');
	$(this).removeClass('active');
	if (!hadActive) {
		$(this).addClass('active');
		wmdPageLink('ar-credit_open', this);
	} else {
		wmdPageLink('ar-credit_close', this);
	}
	e.preventDefault();
})

var posUnique = '';
function addinsertInstreamRecirc() {
        let rootElement = $('#article-content');		
		if ($('.inf-art-wrap').length > 0) {
			rootElement = $('.inf-art-wrap[data-contenturl="' + currSlctCont + '"] #article-content, .inf-art-wrap[data-contenturl="' + currSlctCont + '"] .article__main-content > div:not(.pwHidden) > div:first-child');
			posUnique = '-' + currSlctCont.match(/[^/-]+$/)[0];
		}
		
        let para5th;
        let visbleSelector;
	    if(rootElement.children() && rootElement.children().length > 0){
		
		    rootElement.find('div.csdpages').each(function(i,elem){
			//console.log(i,elem); 
                let checkClass = elem.classList.contains('csdpages');
                if(checkClass){
                    let style = window.getComputedStyle(elem, null);
                    if(style.display !== 'none') {
                        visbleSelector = elem;    
                    }else{
                        //console.log("entered");
                    }
                }
            });

            if(visbleSelector !== undefined){
                //console.log(visbleSelector);
                let pElements1 = $(visbleSelector).children('p');
                para5th = pElements1[4];	
            }
            else{
                let pElements2 = rootElement.children('p');
                para5th = pElements2[4];
            }
	    }	
        if(para5th !== undefined){
			if (rootElement.find('#instream-recirc').length == 0) {
				$('<div id="instream-recirc" style="visibility: hidden;width: 0px;height: 0px;border-top: 1px solid #D8D8D8;border-bottom: 1px solid #D8D8D8;"><div id="top-recirc" style="color:#313131;font-size:18px;padding-bottom: 12px;text-transform: uppercase;line-height: 22px;font-family: proxima_nova_rgbold;">SUGGESTED for you</div><div id="ads-pos-916' + posUnique + '" class="AdUnit globalpromoadsunit" style="background: none;padding:0px;display:none;"></div><div id="ads-pos-917' + posUnique + '" class="AdUnit globalpromoadsunit" style="background: none;padding:0px;display:none;"></div></div>').insertAfter(para5th);
				scrollInstreamRecircEvents.init();
			} else {
				$(window).off("scroll.lazyLoadInstreamRecirc");
			}
        }
    }
	
	var scrollInstreamRecircEvents = {
		init: function (){
			var scrollTimeRecirc;
			$(window).off("scroll.lazyLoadInstreamRecirc");
			$(window).on("scroll.lazyLoadInstreamRecirc", function () {
				let inStreamElement = $('#instream-recirc');
				if ($('.inf-art-wrap').length > 0) {
					inStreamElement = $('.inf-art-wrap[data-contenturl="' + currSlctCont + '"] #instream-recirc');
				}
				if(inStreamElement.length > 0){
					clearTimeout(scrollTimeRecirc);
					scrollTimeRecirc = setTimeout(scrollInstreamRecircEvents.lazyLoadInstreamRecirc(), 250);
				}
			});
		},
	lazyLoadInstreamRecirc: function () {
		let inStreamId = '#instream-recirc';
		if ($('.inf-art-wrap').length > 0) {
			inStreamId = '.inf-art-wrap[data-contenturl="' + currSlctCont + '"] #instream-recirc';
			if (document.querySelector('.inf-art-wrap[data-contenturl="' + currSlctCont + '"] [id*="ads-pos-916"]').id.match(/(-\d+)-.+$/) != null) {
				posUnique = '-' + currSlctCont.match(/[^/-]+$/)[0];
			}
		}
		if (scrollEvents.scrollIntoView(inStreamId) == true) {
				if(!window.scrollInstreamRecirc){
					//$('#ads-pos-1420').show();
					//console.log("inside lazyLoadInstreamRecirc ",window.scrollInstreamRecirc);
					setTimeout(function(){
						window.ads2_ignore["916"] = false;
						window.ads2_ignore["917"] = false;
						window.scrollInstreamRecirc = true;
						webmd.ads2.setPageTarget('ll', '1');
						var dfp916 = {pos: 916, id: ''};
						dfp916.id = 'ads-pos-916' + posUnique;
						var dfp917 = {pos: 917, id: ''};
						dfp917.id = 'ads-pos-917' + posUnique;
						webmd.ads2.defineAd(dfp916);
						webmd.ads2.defineAd(dfp917);
						var dfpRefObj = {id: {}};
						dfpRefObj.id['ads-pos-916' + posUnique] = true;
						dfpRefObj.id['ads-pos-917' + posUnique] = true;
						webmd.ads2.refresh(dfpRefObj);

					},500);
					$(window).off("scroll.lazyLoadInstreamRecirc");
				}
			}
		}
	}

function coeFooterEventEnable () {
    // Sample Coe footer invoking file
    // var coeFooterConfig = {
    //   callback: "loadCoeFooter",
    //   payload: {
    //     "coe-name": "Learn More About the DayTracker™ Pack",
    //     "coe-url": "",
    //     "coe-lead-concept": "",
    //     "lead-concept": "",
    //   },
    // };
    // parent.postMessage(JSON.stringify(coeFooterConfig),'*');
    window.addEventListener('message', (e) => {
        const message = typeof e.data == "string" && e.data.indexOf("loadCoeFooter") > 0 ? JSON.parse(e.data) :"";
        if(message.callback && message.callback == "loadCoeFooter") {
            window.coeFooterData = message.payload;
            const bundleJS = document.createElement('script');
            document.getElementsByTagName("body")[0].appendChild(bundleJS);
            bundleJS.src = `//img.${getDomain()}medscapestatic.com/medscape-core/www/js/article/coe-footer.js`;
        }
    });
}

function pageLevelTackingLinks(product, wrapper){
    $(`${wrapper} a[href]`).each(function(){
        let alink =$(this);
        let text = alink.text().trim().replace(/[^\w-]+/g, '-').substr(0,30).toLowerCase();
        if(!alink.attr('onclick')){
            let trackcall = "wmdTrack";
            if(!alink.attr('href').includes('medscape.com')){
                trackcall = 'wmdPageLink';
                if(!alink.attr('target')){
                    alink.attr('target','_blank')
                }
            }
            alink.attr('onclick',`${trackcall}('${product}-bodylink_${text}',this)`)
        }
    })
}
// pause video on ifi brand alert and on close brand alert resume video player
function PauseVideoIFIBrandAlert(){
    try{
        let observer = new MutationObserver(function(eleList) {
        eleList.forEach(function(mutationlist) {
            mutationlist.addedNodes.forEach(function(node) {
                    if(node.id == 'brandalert') {
                        let ifibrndAlrt = $("iframe#brandalert");
                        ifibrndAlrt.load(function(){
                            let framecontent = ifibrndAlrt.contents();
                            if(framecontent.find(".brandalert").length > 0){
                                player.pause();
                                let onClose = framecontent.find(".brandalert__close");
                                onClose.on('click',function(){
                                    player.appState.playState == 'paused' && player.play()
                                })
                            }
                        })
                        observer.disconnect();
                    }
                });
            });
        });
        observer.observe(document.querySelector("body"), { subtree: false, childList: true });
    }
    catch(err){
        console.error(err);
    }
}
